export const scanner = {
  path: () => (
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5 3C3.89543 3 3 3.89543 3 5V7C3 7.55228 3.44772 8 4 8C4.55228 8 5 7.55228 5 7V5H7C7.55228 5 8 4.55228 8 4C8 3.44772 7.55228 3 7 3H5ZM17 3C16.4477 3 16 3.44772 16 4C16 4.55228 16.4477 5 17 5H19V7C19 7.55228 19.4477 8 20 8C20.5523 8 21 7.55228 21 7V5C21 3.89543 20.1046 3 19 3H17ZM5 17C5 16.4477 4.55228 16 4 16C3.44772 16 3 16.4477 3 17V19C3 20.1046 3.89543 21 5 21H7C7.55228 21 8 20.5523 8 20C8 19.4477 7.55228 19 7 19H5V17ZM21 17C21 16.4477 20.5523 16 20 16C19.4477 16 19 16.4477 19 17V19H17C16.4477 19 16 19.4477 16 20C16 20.5523 16.4477 21 17 21H19C20.1046 21 21 20.1046 21 19V17ZM8 7C7.44772 7 7 7.44772 7 8V16C7 16.5523 7.44772 17 8 17C8.55228 17 9 16.5523 9 16V8C9 7.44772 8.55228 7 8 7ZM11 8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V8ZM16 7C15.4477 7 15 7.44772 15 8V16C15 16.5523 15.4477 17 16 17C16.5523 17 17 16.5523 17 16V8C17 7.44772 16.5523 7 16 7Z"
      fill="currentColor"
    />
  ),
  outline: false,
};

export const wifiOffline = {
  path: () => (
    <>
      <path d="M18 7L6.93877 16.165" stroke="currentColor" stroke-width="1.28571" stroke-linecap="round" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.4261 6.22579C14.115 2.79469 6.95177 3.40518 2.29968 8.05726C1.88778 8.46917 1.88778 9.137 2.29968 9.54891C2.71159 9.96081 3.37942 9.96081 3.79133 9.54891C7.56184 5.7784 13.2819 5.14557 17.7068 7.65041L19.4261 6.22579ZM18.839 8.38195L20.5062 7.00056C20.9163 7.32596 21.312 7.67819 21.6911 8.05726C22.103 8.46917 22.103 9.137 21.6911 9.54891C21.2792 9.96081 20.6114 9.96081 20.1994 9.54891C19.7697 9.11916 19.3146 8.73018 18.839 8.38195ZM15.9389 9.11523C12.4375 7.5173 8.16446 8.15908 5.28298 11.0406C4.87107 11.4525 4.87107 12.1203 5.28298 12.5322C5.69488 12.9441 6.36272 12.9441 6.77462 12.5322C8.74923 10.5576 11.564 9.93527 14.0682 10.6652L15.9389 9.11523ZM15.4238 11.2117L17.1515 9.78021C17.7026 10.1374 18.2247 10.5575 18.7078 11.0406C19.1197 11.4525 19.1197 12.1203 18.7078 12.5322C18.2959 12.9441 17.6281 12.9441 17.2162 12.5322C16.6741 11.9901 16.0687 11.55 15.4238 11.2117ZM11.8773 12.4805C10.5673 12.5097 9.26601 13.0241 8.26627 14.0239C7.86222 14.4279 7.85451 15.0782 8.24317 15.4917L11.8773 12.4805ZM11.2376 14.6803L13.5954 12.7266C14.3742 12.9738 15.1069 13.4062 15.7245 14.0239C16.1364 14.4358 16.1364 15.1036 15.7245 15.5155C15.3126 15.9274 14.6448 15.9274 14.2329 15.5155C13.4207 14.7034 12.277 14.425 11.2376 14.6803ZM11.9954 16.6982C11.4129 16.6982 10.9406 17.1705 10.9406 17.753C10.9406 18.3355 11.4129 18.8077 11.9954 18.8077H12.0059C12.5885 18.8077 13.0607 18.3355 13.0607 17.753C13.0607 17.1705 12.5885 16.6982 12.0059 16.6982H11.9954Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const lifeBuoy = {
  path: () => (
    <>
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.92999 4.92999L9.16999 9.16999"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.83 14.83L19.07 19.07"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.83 9.16999L19.07 4.92999"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.83 9.17001L18.36 5.64001"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.92999 19.07L9.16999 14.83"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </>
  ),
  outline: true,
};

export const currencyFranc = {
  path: () => (
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM10.4693 18.5909C9.98934 18.5909 9.60022 18.2018 9.60022 17.7218V15.8257H6.375C6.09886 15.8257 5.87501 15.6018 5.87501 15.3257C5.87501 15.0496 6.09886 14.8257 6.375 14.8257H9.60022V6.31033C9.60022 6.00087 9.85109 5.75 10.1605 5.75H15.9963C16.4095 5.75 16.7444 6.08497 16.7444 6.49817C16.7444 6.91138 16.4095 7.24635 15.9963 7.24635H11.4687C11.3968 7.24635 11.3385 7.30467 11.3385 7.37661V10.7566H15.4872C15.8988 10.7566 16.2325 11.0903 16.2325 11.5019C16.2325 11.9136 15.8988 12.2473 15.4872 12.2473H11.3385V14.8257H14.2955C14.5717 14.8257 14.7955 15.0496 14.7955 15.3257C14.7955 15.6018 14.5717 15.8257 14.2955 15.8257H11.3385V17.7218C11.3385 18.2018 10.9493 18.5909 10.4693 18.5909Z"
      fill="currentColor"
    />
  ),
  outline: false,
};

export const route = {
  path: () => (
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.4136 2.58577C12.6325 1.80475 11.3661 1.80474 10.585 2.58577L2.58581 10.5844C1.80473 11.3654 1.80473 12.6317 2.58581 13.4127L10.585 21.4114C11.3661 22.1924 12.6325 22.1924 13.4136 21.4114L21.4128 13.4127C22.1939 12.6317 22.1939 11.3654 21.4128 10.5844L13.4136 2.58577ZM13.4265 8.4165C13.1649 8.16023 13.1649 7.74474 13.4265 7.48847C13.6881 7.2322 14.1123 7.2322 14.3739 7.48847L17.0536 10.1133C17.3153 10.3696 17.3153 10.7851 17.0536 11.0414L14.3739 13.6662C14.1123 13.9225 13.6881 13.9225 13.4265 13.6662C13.1649 13.4099 13.1649 12.9945 13.4265 12.7382L14.9626 11.2336H11.2205C9.37049 11.2336 7.8708 12.7025 7.8708 14.5146V15.8271C7.8708 16.1895 7.57086 16.4833 7.20086 16.4833C6.83087 16.4833 6.53093 16.1895 6.53093 15.8271V14.5146C6.53093 11.9777 8.6305 9.92112 11.2205 9.92112H14.9626L13.4265 8.4165Z"
      fill="currentColor"
    />
  ),
  outline: false,
};

export const gpsLocation = {
  path: () => (
    <>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.9998 1.99987C13.1044 1.99987 13.9999 2.89531 13.9999 3.9999V4.76955C16.5344 5.46908 18.5308 7.4655 19.2303 9.99999H20C21.1046 9.99999 22 10.8954 22 12C22 13.1046 21.1046 14.0001 20 14.0001H19.2303C18.5308 16.5346 16.5344 18.531 13.9999 19.2305V20.0002C13.9999 21.1047 13.1044 22.0002 11.9998 22.0002C10.8953 22.0002 9.99981 21.1047 9.99981 20.0002V19.2305C7.46529 18.531 5.46885 16.5346 4.76933 14.0001H3.99972C2.89513 14.0001 1.99968 13.1046 1.99968 12C1.99968 10.8954 2.89513 9.99999 3.99972 9.99999H4.76934C5.46887 7.46549 7.46531 5.46907 9.99981 4.76955V3.9999C9.99981 2.89531 10.8953 1.99987 11.9998 1.99987ZM11.9999 16.8C14.6508 16.8 16.7999 14.651 16.7999 12C16.7999 9.34902 14.6508 7.19999 11.9999 7.19999C9.3489 7.19999 7.19986 9.34902 7.19986 12C7.19986 14.651 9.3489 16.8 11.9999 16.8Z"
        fill="currentColor"
      />
      <circle cx="12" cy="12" r="3.6" fill="currentColor" />
    </>
  ),
  outline: false,
};

export const spinner = {
  path: () => (
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.8 3.77142C10.8 3.014 11.414 2.39999 12.1714 2.39999C17.4734 2.39999 21.7714 6.69806 21.7714 12C21.7714 12.7574 21.1574 13.3714 20.4 13.3714C19.6426 13.3714 19.0286 12.7574 19.0286 12C19.0286 8.2129 15.9585 5.14285 12.1714 5.14285C11.414 5.14285 10.8 4.52884 10.8 3.77142Z"
      fill="currentColor"
    />
  ),
  outline: false,
};

export const textIcon = {
  path: () => (
    <>
      <path
        d="M4.32411 17.8211H2L6.23153 6H8.91952L13.1569 17.8211H10.8328L7.62248 8.42424H7.52857L4.32411 17.8211ZM4.40041 13.1861H10.7389V14.9062H4.40041V13.1861Z"
        fill="currentColor"
      />
      <path
        d="M17.2403 18C16.669 18 16.1545 17.9 15.6967 17.6999C15.2429 17.4959 14.8829 17.1958 14.6168 16.7994C14.3547 16.4031 14.2236 15.9144 14.2236 15.3333C14.2236 14.8331 14.3175 14.4194 14.5053 14.0924C14.6931 13.7653 14.9494 13.5036 15.2742 13.3074C15.5989 13.1111 15.9647 12.963 16.3717 12.8629C16.7825 12.759 17.207 12.684 17.6452 12.6378C18.1734 12.5839 18.6019 12.5358 18.9305 12.4935C19.2592 12.4473 19.4979 12.3781 19.6465 12.2857C19.7991 12.1895 19.8754 12.0414 19.8754 11.8413V11.8066C19.8754 11.3718 19.7444 11.0351 19.4822 10.7965C19.2201 10.558 18.8425 10.4387 18.3495 10.4387C17.8291 10.4387 17.4163 10.5503 17.1111 10.7734C16.8099 10.9966 16.6064 11.2602 16.5008 11.5642L14.5171 11.2872C14.6736 10.7484 14.9318 10.2982 15.2918 9.93651C15.6517 9.57095 16.0919 9.29774 16.6123 9.11688C17.1327 8.93218 17.7078 8.83983 18.3378 8.83983C18.7721 8.83983 19.2044 8.88985 19.6348 8.9899C20.0652 9.08995 20.4584 9.25541 20.8145 9.48629C21.1705 9.71332 21.4561 10.0231 21.6713 10.4156C21.8904 10.8081 22 11.2987 22 11.8874V17.8211H19.9576V16.6032H19.8872C19.7581 16.8494 19.5761 17.0803 19.3414 17.2958C19.1105 17.5075 18.819 17.6787 18.4669 17.8095C18.1187 17.9365 17.7098 18 17.2403 18ZM17.7919 16.4646C18.2184 16.4646 18.5882 16.3819 18.9012 16.2165C19.2142 16.0471 19.4548 15.824 19.6231 15.5469C19.7952 15.2698 19.8813 14.9678 19.8813 14.6407V13.596C19.8148 13.6498 19.7013 13.6999 19.5409 13.746C19.3844 13.7922 19.2083 13.8326 19.0127 13.8672C18.8171 13.9019 18.6234 13.9327 18.4317 13.9596C18.2399 13.9865 18.0737 14.0096 17.9328 14.0289C17.6159 14.0712 17.3322 14.1405 17.0818 14.2367C16.8314 14.3329 16.6338 14.4675 16.489 14.6407C16.3443 14.81 16.2719 15.0293 16.2719 15.2987C16.2719 15.6835 16.4147 15.974 16.7003 16.1703C16.9859 16.3665 17.3498 16.4646 17.7919 16.4646Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const vector = {
  path: () => (
    <path
      d="M4.85714 3H19.1429C19.9004 3.00087 20.6266 3.31722 21.1622 3.87964C21.6979 4.44206 21.9992 5.20462 22 6V18C21.9992 18.7954 21.6979 19.5579 21.1622 20.1204C20.6266 20.6828 19.9004 20.9991 19.1429 21H4.85714C4.09964 20.9991 3.37339 20.6828 2.83775 20.1204C2.30211 19.5579 2.00083 18.7954 2 18V6C2.00083 5.20462 2.30211 4.44206 2.83775 3.87964C3.37339 3.31722 4.09964 3.00087 4.85714 3ZM8.42857 6C8.00476 6 7.59046 6.13196 7.23806 6.37919C6.88567 6.62643 6.61102 6.97783 6.44883 7.38896C6.28664 7.8001 6.24421 8.2525 6.32689 8.68895C6.40957 9.12541 6.61366 9.52632 6.91334 9.84099C7.21303 10.1557 7.59485 10.37 8.01052 10.4568C8.42619 10.5436 8.85705 10.499 9.24861 10.3287C9.64016 10.1584 9.97483 9.87004 10.2103 9.50003C10.4458 9.13002 10.5714 8.69501 10.5714 8.25C10.5708 7.65345 10.3449 7.08152 9.94315 6.65969C9.54141 6.23787 8.99671 6.00062 8.42857 6ZM19.1429 19.5C19.5217 19.5 19.8851 19.342 20.153 19.0607C20.4209 18.7794 20.5714 18.3978 20.5714 18V14.8298L16.3375 10.8783C15.929 10.4979 15.3977 10.2953 14.8519 10.3119C14.3062 10.3284 13.7869 10.5628 13.4 10.9673L10.5004 14.0053L15.7335 19.5H19.1429ZM3.42857 18C3.42857 18.3978 3.57908 18.7794 3.84699 19.0607C4.1149 19.342 4.47826 19.5 4.85714 19.5H13.7129L8.29241 13.8084C7.90863 13.4657 7.42161 13.277 6.91783 13.2756C6.41404 13.2742 5.92609 13.4603 5.54062 13.8009L3.42857 15.6488V18Z"
      fill="currentColor"
    />
  ),
  outline: false,
};

export const leaf = {
  path: () => (
    <path
      d="M18.0668 2.30382C17.8918 1.91325 17.3919 1.89763 17.1826 2.26633C16.214 3.95048 14.4798 5.00034 12.4988 5.00034H9.99916C6.6871 5.00034 3.99996 7.68748 3.99996 10.9995C3.99996 11.2183 4.02496 11.4276 4.04683 11.6401C6.04031 10.2121 8.91805 8.9998 12.9988 8.9998C13.2737 8.9998 13.4987 9.22477 13.4987 9.49973C13.4987 9.7747 13.2737 9.99967 12.9988 9.99967C5.14356 9.99967 1.81276 14.8146 1.07536 16.6238C0.869133 17.1331 1.11285 17.7143 1.62216 17.9236C2.13459 18.1361 2.71576 17.8892 2.92823 17.383C2.9751 17.2706 3.58127 15.8864 5.17481 14.5522C6.18717 15.9239 8.11191 17.2331 10.6397 16.9644C15.5453 16.6082 18.998 12.2087 18.998 6.82197C18.998 5.25343 18.6605 3.62865 18.0668 2.30382Z"
      fill="currentColor"
    />
  ),
  outline: false,
};

export const flame = {
  path: () => (
    <path
      d="M15.6496 7.46719C15.1657 6.18239 14.4601 4.99247 13.5648 3.95156C12.0156 2.1582 9.97852 1 8.375 1C8.27965 1.00007 8.18559 1.02196 8.1 1.06398C8.01441 1.106 7.93958 1.16705 7.88122 1.24245C7.82286 1.31785 7.78252 1.4056 7.7633 1.49899C7.74408 1.59238 7.74648 1.68893 7.77031 1.78125C8.31211 3.85156 7.18906 5.57305 6.00039 7.39531C5.01563 8.90469 4 10.4637 4 12.25C4 15.6961 6.80391 18.5 10.25 18.5C13.6961 18.5 16.5 15.6961 16.5 12.25C16.5 10.5586 16.2141 8.94961 15.6496 7.46719ZM11.5129 16.1051C11.1094 16.5348 10.6035 16.625 10.25 16.625C9.89648 16.625 9.39062 16.5348 8.98711 16.1051C8.58359 15.6754 8.375 14.9937 8.375 14.125C8.375 13.143 8.71953 12.3953 9.05234 11.6727C9.2457 11.2531 9.44297 10.8262 9.56016 10.3691C9.5726 10.3194 9.59708 10.2735 9.63143 10.2355C9.66579 10.1975 9.70897 10.1685 9.75717 10.1511C9.80537 10.1337 9.85711 10.1284 9.90784 10.1357C9.95856 10.143 10.0067 10.1627 10.048 10.193C10.4053 10.4694 10.723 10.7935 10.9922 11.1562C11.702 12.0938 12.125 13.2039 12.125 14.125C12.125 14.9937 11.9133 15.6785 11.5129 16.1051Z"
      fill="currentColor"
    />
  ),
  outline: false,
};

export const bold = {
  path: () => (
    <path
      d="M6 20V4H12.1571C13.3194 4 14.2853 4.18229 15.055 4.54687C15.8298 4.90625 16.4084 5.39844 16.7906 6.02344C17.178 6.64844 17.3717 7.35677 17.3717 8.14844C17.3717 8.79948 17.2461 9.35677 16.9948 9.82031C16.7435 10.2786 16.4058 10.651 15.9817 10.9375C15.5576 11.224 15.0838 11.4297 14.5602 11.5547V11.7109C15.1309 11.7422 15.678 11.9167 16.2016 12.2344C16.7304 12.5469 17.1623 12.9896 17.4974 13.5625C17.8325 14.1354 18 14.8281 18 15.6406C18 16.4687 17.7984 17.2135 17.3953 17.875C16.9921 18.5312 16.3848 19.0495 15.5733 19.4297C14.7618 19.8099 13.7408 20 12.5105 20H6ZM8.91361 17.5781H12.0471C13.1047 17.5781 13.8665 17.3776 14.3325 16.9766C14.8037 16.5703 15.0393 16.0495 15.0393 15.4141C15.0393 14.9401 14.9215 14.513 14.6859 14.1328C14.4503 13.7474 14.1152 13.4453 13.6806 13.2266C13.2461 13.0026 12.7277 12.8906 12.1257 12.8906H8.91361V17.5781ZM8.91361 10.8047H11.7958C12.2984 10.8047 12.7513 10.7135 13.1545 10.5312C13.5576 10.3437 13.8743 10.0807 14.1047 9.74219C14.3403 9.39844 14.4581 8.99219 14.4581 8.52344C14.4581 7.90365 14.2382 7.39323 13.7984 6.99219C13.3639 6.59115 12.7173 6.39062 11.8586 6.39062H8.91361V10.8047Z"
      fill="currentColor"
    />
  ),
  outline: false,
};

export const italic = {
  path: () => (
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18 6.46153H14.2123L12.2201 17.5385H16.6667V20L11.7774 20H8.96681L6 20V17.5385H9.40952L11.4017 6.46153H7.33331V4H18V6.46153Z"
      fill="currentColor"
    />
  ),
  outline: false,
};

export const underline = {
  path: () => (
    <>
      <path
        d="M14.8989 4H16.8889V11.6971C16.8889 12.5162 16.6728 13.2419 16.2406 13.8743C15.8083 14.5029 15.2006 14.9981 14.4174 15.36C13.6342 15.7181 12.7163 15.8971 11.6635 15.8971C10.6149 15.8971 9.69908 15.7181 8.9159 15.36C8.13272 14.9981 7.52501 14.5029 7.09276 13.8743C6.66051 13.2419 6.44439 12.5162 6.44439 11.6971V4H8.42802V11.5543C8.42802 12.0838 8.55855 12.5543 8.81961 12.9657C9.08495 13.3771 9.45942 13.701 9.94303 13.9371C10.4266 14.1695 11.0001 14.2857 11.6635 14.2857C12.3311 14.2857 12.9067 14.1695 13.3903 13.9371C13.8782 13.701 14.2505 13.3771 14.5073 12.9657C14.7684 12.5543 14.8989 12.0838 14.8989 11.5543V4Z"
        fill="currentColor"
      />
      <path d="M5 18.9029H18.3333V20H5V18.9029Z" fill="currentColor" />
    </>
  ),
  outline: false,
};

export const listBullet = {
  path: () => (
    <>
      <path
        d="M9.73469 16.2857C9.32893 16.2857 9 16.6695 9 17.1429C9 17.6162 9.32893 18 9.73469 18H18.551C18.9568 18 19.2857 17.6162 19.2857 17.1429C19.2857 16.6695 18.9568 16.2857 18.551 16.2857H9.73469Z"
        fill="currentColor"
      />
      <path
        d="M9.73469 11.1429C9.32893 11.1429 9 11.5266 9 12C9 12.4734 9.32893 12.8571 9.73469 12.8571H18.551C18.9568 12.8571 19.2857 12.4734 19.2857 12C19.2857 11.5266 18.9568 11.1429 18.551 11.1429H9.73469Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9 6.85714C9 6.38376 9.32893 6 9.73469 6H18.551C18.9568 6 19.2857 6.38376 19.2857 6.85714C19.2857 7.33053 18.9568 7.71429 18.551 7.71429H9.73469C9.32893 7.71429 9 7.33053 9 6.85714Z"
        fill="currentColor"
      />
      <path
        d="M7 7C7 7.55228 6.55228 8 6 8C5.44772 8 5 7.55228 5 7C5 6.44772 5.44772 6 6 6C6.55228 6 7 6.44772 7 7Z"
        fill="currentColor"
      />
      <path
        d="M7 12C7 12.5523 6.55228 13 6 13C5.44772 13 5 12.5523 5 12C5 11.4477 5.44772 11 6 11C6.55228 11 7 11.4477 7 12Z"
        fill="currentColor"
      />
      <path
        d="M7 17C7 17.5523 6.55228 18 6 18C5.44772 18 5 17.5523 5 17C5 16.4477 5.44772 16 6 16C6.55228 16 7 16.4477 7 17Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const listNumber = {
  path: () => (
    <>
      <path
        d="M9.30286 16.64C8.84841 16.64 8.48 17.0698 8.48 17.6C8.48 18.1302 8.84841 18.56 9.30286 18.56H19.1771C19.6316 18.56 20 18.1302 20 17.6C20 17.0698 19.6316 16.64 19.1771 16.64H9.30286Z"
        fill="currentColor"
      />
      <path
        d="M9.30286 10.88C8.84841 10.88 8.48 11.3098 8.48 11.84C8.48 12.3702 8.84841 12.8 9.30286 12.8H19.1771C19.6316 12.8 20 12.3702 20 11.84C20 11.3098 19.6316 10.88 19.1771 10.88H9.30286Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.48 6.07999C8.48 5.5498 8.84841 5.11999 9.30286 5.11999H19.1771C19.6316 5.11999 20 5.5498 20 6.07999C20 6.61019 19.6316 7.03999 19.1771 7.03999H9.30286C8.84841 7.03999 8.48 6.61019 8.48 6.07999Z"
        fill="currentColor"
      />
      <path d="M5.73946 4V7.8976H4.9154V4.78218H4.89257L4 5.3417V4.6109L4.96488 4H5.73946Z" fill="currentColor" />
      <path
        d="M4.03755 13.4976V12.9119L5.40621 11.6446C5.52262 11.5319 5.62024 11.4305 5.6991 11.3404C5.7792 11.2503 5.83991 11.1621 5.88121 11.0757C5.92251 10.9881 5.94317 10.8936 5.94317 10.7922C5.94317 10.6796 5.91751 10.5826 5.86619 10.5012C5.81487 10.4186 5.74478 10.3554 5.65592 10.3116C5.56705 10.2665 5.46629 10.244 5.35365 10.244C5.23599 10.244 5.13336 10.2678 5.04574 10.3153C4.95813 10.3629 4.89054 10.4311 4.84298 10.52C4.79542 10.6088 4.77163 10.7146 4.77163 10.8373H4C4 10.5857 4.05695 10.3673 4.17085 10.182C4.28475 9.99679 4.44433 9.85348 4.6496 9.7521C4.85487 9.65071 5.09143 9.60002 5.35928 9.60002C5.63464 9.60002 5.87433 9.64884 6.07834 9.74646C6.28361 9.84284 6.4432 9.97677 6.55709 10.1482C6.67099 10.3197 6.72794 10.5162 6.72794 10.7378C6.72794 10.8829 6.69916 11.0263 6.64158 11.1677C6.58526 11.3091 6.4845 11.4662 6.33931 11.6389C6.19412 11.8104 5.98948 12.0163 5.72538 12.2566L5.16402 12.8067V12.833H6.77863V13.4976H4.03755Z"
        fill="currentColor"
      />
      <path
        d="M5.43937 19.0975C5.16273 19.0975 4.91636 19.05 4.70023 18.9549C4.48535 18.8586 4.31554 18.7264 4.1908 18.5585C4.06731 18.3893 4.0037 18.1942 4 17.9731H4.80768C4.81262 18.0657 4.84287 18.1472 4.89845 18.2176C4.95526 18.2868 5.03059 18.3405 5.12445 18.3788C5.21831 18.4171 5.3239 18.4362 5.44122 18.4362C5.56348 18.4362 5.67155 18.4146 5.7654 18.3714C5.85926 18.3281 5.93274 18.2683 5.98585 18.1917C6.03895 18.1151 6.0655 18.0268 6.0655 17.9268C6.0655 17.8255 6.0371 17.736 5.98029 17.6582C5.92472 17.5791 5.84444 17.5174 5.73947 17.4729C5.63573 17.4285 5.51223 17.4062 5.36898 17.4062H5.01515V16.8172H5.36898C5.49 16.8172 5.59683 16.7962 5.68945 16.7542C5.78331 16.7122 5.85618 16.6541 5.90804 16.58C5.95991 16.5047 5.98585 16.417 5.98585 16.317C5.98585 16.2219 5.963 16.1385 5.91731 16.0669C5.87285 15.994 5.80986 15.9372 5.72835 15.8965C5.64808 15.8557 5.55422 15.8353 5.44678 15.8353C5.3381 15.8353 5.23869 15.8551 5.14853 15.8946C5.05838 15.9329 4.98613 15.9879 4.93179 16.0595C4.87745 16.1311 4.84843 16.2151 4.84473 16.3114H4.07595C4.07966 16.0928 4.14202 15.9002 4.26305 15.7335C4.38408 15.5667 4.5471 15.4364 4.7521 15.3426C4.95834 15.2475 5.19114 15.1999 5.45048 15.1999C5.7123 15.1999 5.94139 15.2475 6.13775 15.3426C6.33411 15.4377 6.48663 15.5661 6.59531 15.7279C6.70522 15.8884 6.75956 16.0688 6.75833 16.2688C6.75956 16.4812 6.69349 16.6585 6.56011 16.8005C6.42797 16.9425 6.25569 17.0327 6.04327 17.0709V17.1006C6.32238 17.1364 6.5348 17.2333 6.68052 17.3914C6.82749 17.5483 6.90035 17.7446 6.89912 17.9805C6.90035 18.1966 6.83798 18.3887 6.71202 18.5566C6.58728 18.7246 6.415 18.8567 6.19518 18.953C5.97535 19.0494 5.72341 19.0975 5.43937 19.0975Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const filter = {
  path: () => (
    <path
      d="M15.7334 17L15.8359 17.0049C16.34 17.0562 16.7334 17.4823 16.7334 18C16.7334 18.5177 16.34 18.9438 15.8359 18.9951L15.7334 19H8.2666C7.71435 19 7.2666 18.5523 7.2666 18C7.2666 17.4477 7.71435 17 8.2666 17H15.7334ZM17.8662 11L17.9688 11.0049C18.4731 11.056 18.8662 11.4822 18.8662 12C18.8662 12.5178 18.4731 12.944 17.9688 12.9951L17.8662 13H6.13379C5.5815 13 5.13379 12.5523 5.13379 12C5.13379 11.4477 5.5815 11 6.13379 11H17.8662ZM20 5C20.5523 5 21 5.44772 21 6C21 6.55228 20.5523 7 20 7H4C3.44772 7 3 6.55228 3 6C3 5.44772 3.44772 5 4 5H20Z"
      fill="currentColor"
    />
  ),
  outline: false,
};

export const sections = {
  path: () => (
    <>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2 5C2 3.89543 2.89543 3 4 3H16C17.1046 3 18 3.89543 18 5V7C18 8.10457 17.1046 9 16 9H4C2.89543 9 2 8.10457 2 7V5Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2 13C2 11.8954 2.89543 11 4 11H16C17.1046 11 18 11.8954 18 13V15C18 16.1046 17.1046 17 16 17H4C2.89543 17 2 16.1046 2 15V13Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const pin = {
  path: () => (
    <>
      <path
        d="M16 8C16 10.2091 14.2091 12 12 12C9.79086 12 8 10.2091 8 8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 6C12.5523 6 13 6.44772 13 7L13 19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19L11 7C11 6.44772 11.4477 6 12 6Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const checkbox = {
  path: () => (
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.75 3C19.9926 3 20.9999 4.15119 21 5.57129V18.4287C20.9999 19.8487 19.9926 21 18.75 21H5.25C4.00744 21 3.00014 19.8487 3 18.4287V5.57129C3.00005 4.15121 4.00739 3.00003 5.25 3H18.75ZM16.2578 9.31348C15.8394 8.89519 15.1606 8.89513 14.7422 9.31348L12.9785 11.0781L11.2139 12.8418L9.8291 11.457C9.41068 11.0386 8.7319 11.0386 8.31348 11.457C7.8955 11.8754 7.89543 12.5534 8.31348 12.9717L10.457 15.1143C10.8755 15.5327 11.5533 15.5327 11.9717 15.1143L14.1152 12.9717L16.2578 10.8291C16.6762 10.4107 16.6762 9.73189 16.2578 9.31348Z"
      fill="currentColor"
    />
  ),
  outline: false,
};

export const dateTime = {
  path: () => (
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.7998 2.40039C17.4624 2.40039 17.9998 2.93705 18 3.59961V4.7998H19.2002C20.5256 4.79991 21.5996 5.87478 21.5996 7.2002V19.2002C21.5995 20.5255 20.5255 21.5995 19.2002 21.5996H4.7998C3.47448 21.5995 2.4005 20.5255 2.40039 19.2002V7.2002C2.40039 5.87478 3.47441 4.79991 4.7998 4.7998H6V3.59961C6.00021 2.93705 6.53758 2.40039 7.2002 2.40039C7.86272 2.4005 8.40018 2.93711 8.40039 3.59961V4.7998H15.5996V3.59961C15.5998 2.93711 16.1373 2.4005 16.7998 2.40039ZM11.7998 9.59961C11.2477 9.59972 10.8 10.0476 10.7998 10.5996V13.5996C10.7998 13.8647 10.9054 14.1191 11.0928 14.3066L13.9209 17.1357C14.3114 17.5263 14.9454 17.5263 15.3359 17.1357C15.7262 16.7453 15.726 16.1122 15.3359 15.7217L12.7998 13.1855V10.5996C12.7996 10.0475 12.352 9.59961 11.7998 9.59961Z"
      fill="currentColor"
    />
  ),
  outline: false,
};

export const discount = {
  path: () => (
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.7071 10.7071C18.0976 10.3166 18.0976 9.68342 17.7071 9.29289L10.7071 2.29289C10.5119 2.0977 10.2561 2.00007 10.0003 2H5C3.34315 2 2 3.34315 2 5V9.99988C1.99997 10.2558 2.0976 10.5118 2.29289 10.7071L9.29289 17.7071C9.68342 18.0976 10.3166 18.0976 10.7071 17.7071L17.7071 10.7071ZM6 5C6 5.55228 5.55228 6 5 6C4.44772 6 4 5.55228 4 5C4 4.44772 4.44772 4 5 4C5.55228 4 6 4.44772 6 5ZM9.18432 11.5543L8.94421 11.7957C8.75746 11.9836 8.62428 12.1965 8.54469 12.4345C8.46659 12.6741 8.45688 12.9194 8.51557 13.1704C8.57425 13.4214 8.71688 13.6596 8.94346 13.8849C9.16854 14.1087 9.40751 14.25 9.66037 14.3087C9.91323 14.3675 10.1592 14.3571 10.3983 14.2776C10.6374 14.1982 10.8503 14.0645 11.0371 13.8767L11.2772 13.6352C11.4669 13.4444 11.6001 13.23 11.6767 12.992C11.7563 12.7539 11.7652 12.5094 11.7036 12.2584C11.6449 12.0073 11.5015 11.7684 11.2734 11.5416C11.0499 11.3193 10.8124 11.1795 10.561 11.1223C10.3096 11.065 10.0637 11.0754 9.82309 11.1533C9.584 11.2328 9.37108 11.3664 9.18432 11.5543ZM9.65748 12.505L9.89759 12.2635C9.9969 12.1636 10.1141 12.0934 10.2493 12.0529C10.3859 12.0109 10.5168 12.0521 10.642 12.1766C10.7762 12.31 10.8197 12.4422 10.7725 12.5731C10.7283 12.7041 10.6565 12.8195 10.5572 12.9193L10.3171 13.1608C10.2178 13.2607 10.1028 13.3316 9.97209 13.3736C9.84289 13.4141 9.71344 13.3699 9.58376 13.241C9.45706 13.115 9.41358 12.9843 9.45333 12.8489C9.49457 12.715 9.56262 12.6004 9.65748 12.505ZM8.89073 6.05089L8.65062 6.29237C8.46386 6.48019 8.33143 6.69238 8.25332 6.92895C8.1767 7.16699 8.16848 7.41079 8.22864 7.66033C8.2903 7.91136 8.43367 8.14878 8.65876 8.37259C8.88384 8.5964 9.12133 8.73916 9.37122 8.80088C9.62112 8.8626 9.86487 8.85448 10.1025 8.77651C10.3416 8.70002 10.556 8.56638 10.7457 8.37558L10.9858 8.1341C11.1755 7.9433 11.3087 7.72888 11.3853 7.49083C11.4634 7.2513 11.4716 7.00602 11.41 6.75499C11.3513 6.50395 11.2079 6.26504 10.9799 6.03827C10.7592 5.81891 10.5233 5.6806 10.2719 5.62334C10.022 5.56459 9.77602 5.57347 9.53395 5.64996C9.29486 5.72645 9.08045 5.86009 8.89073 6.05089ZM9.37059 7.00827L9.6107 6.76679C9.70556 6.67139 9.82056 6.60045 9.95569 6.55399C10.0923 6.50901 10.2232 6.54877 10.3484 6.67328C10.4841 6.80815 10.5283 6.94106 10.4811 7.072C10.4354 7.20145 10.3629 7.31611 10.2636 7.41598L10.0235 7.65746C9.92418 7.75734 9.80918 7.82827 9.6785 7.87026C9.55078 7.91224 9.42134 7.86802 9.29017 7.73758C9.16793 7.61604 9.12521 7.48908 9.16199 7.35668C9.20175 7.22428 9.27128 7.10814 9.37059 7.00827ZM6.76103 9.8754C6.23913 9.97359 6.04135 10.6168 6.41792 10.9913C6.57193 11.1444 6.79146 11.2119 7.0049 11.1718L13.1332 10.0189C13.6551 9.92068 13.8529 9.27744 13.4763 8.903C13.3223 8.74986 13.1028 8.68236 12.8893 8.72252L6.76103 9.8754Z"
      fill="currentColor"
    />
  ),
  outline: false,
};

export const dragAndDrop = {
  path: () => (
    <>
      <path
        d="M13.35 14.92V15.64H12.09V14.92H13.35ZM15.87 14.92V15.64H14.61V14.92H15.87ZM18.39 14.92V15.64H17.13V14.92H18.39ZM20.28 14.92V15.64H19.65V14.92H20.28ZM21 14.92C21 15.3176 20.6776 15.64 20.28 15.64V14.29H21V14.92ZM10.2 11.77V13.03H9.48V11.77H10.2ZM21 11.77V13.03H20.28V11.77H21ZM10.2 9.24996V10.51H9.48V9.24996H10.2ZM21 9.24996V10.51H20.28V9.24996H21ZM10.2 6.72996V7.98996H9.48V6.72996H10.2ZM21 6.72996V7.98996H20.28V6.72996H21ZM9.48 4.83996C9.48 4.44232 9.80236 4.11996 10.2 4.11996H10.83V4.83996H10.2V5.46996H9.48V4.83996ZM21 5.46996H20.28V4.83996H19.65V4.11996H20.28C20.6776 4.11996 21 4.44232 21 4.83996V5.46996ZM13.35 4.11996V4.83996H12.09V4.11996H13.35ZM15.87 4.11996V4.83996H14.61V4.11996H15.87ZM18.39 4.11996V4.83996H17.13V4.11996H18.39Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.24 8.07995C15.4388 8.07995 15.6 8.24113 15.6 8.43995V9.51995L16.68 9.51995C16.8788 9.51995 17.04 9.68113 17.04 9.87995C17.04 10.0788 16.8788 10.2399 16.68 10.2399H15.6V11.3199C15.6 11.5188 15.4388 11.6799 15.24 11.6799C15.0412 11.6799 14.88 11.5188 14.88 11.3199V10.2399H13.8C13.6012 10.2399 13.44 10.0788 13.44 9.87995C13.44 9.68113 13.6012 9.51995 13.8 9.51995H14.88V8.43995C14.88 8.24113 15.0412 8.07995 15.24 8.07995Z"
        fill="currentColor"
      />
      <path
        d="M14.52 19.24C14.52 19.6376 14.1976 19.96 13.8 19.96H3.72C3.32236 19.96 3 19.6376 3 19.24V9.15997C3 8.76232 3.32235 8.43996 3.72 8.43996H13.8C14.1976 8.43996 14.52 8.76232 14.52 9.15996V19.24ZM7.75242 12.7245C7.61873 12.671 7.46611 12.7025 7.3643 12.8043C7.26249 12.9061 7.23105 13.0587 7.28449 13.1924L8.72449 16.7924C8.77713 16.924 8.90212 17.0125 9.04371 17.0184C9.18535 17.0243 9.31746 16.9466 9.38086 16.8198L9.87727 15.8266L10.9643 16.9133C11.1049 17.0539 11.3328 17.0539 11.4734 16.9133C11.6139 16.7727 11.6139 16.5449 11.4734 16.4043L10.3867 15.3172L11.3798 14.8208C11.5066 14.7574 11.5844 14.6253 11.5785 14.4837C11.5725 14.3421 11.484 14.2171 11.3524 14.1645L7.75242 12.7245ZM6.85523 13.8224C6.71465 13.6818 6.48641 13.6818 6.34582 13.8224L6.09129 14.0769C5.95077 14.2175 5.95082 14.4454 6.09129 14.586C6.23186 14.7266 6.45976 14.7265 6.60035 14.586L6.85523 14.3314C6.99569 14.1909 6.99571 13.9629 6.85523 13.8224ZM5.97316 12.2453C5.78113 12.1939 5.58376 12.3078 5.5323 12.4998C5.48094 12.6918 5.59487 12.8892 5.78684 12.9407L6.13453 13.0338C6.32653 13.0853 6.52387 12.9713 6.57539 12.7793C6.62685 12.5873 6.51291 12.3899 6.32086 12.3384L5.97316 12.2453ZM9.14602 11.5313C9.00543 11.3908 8.77751 11.3907 8.63695 11.5313L8.38242 11.7858C8.24183 11.9264 8.24183 12.1546 8.38242 12.2952C8.52298 12.4357 8.75091 12.4357 8.89148 12.2952L9.14602 12.0403C9.28656 11.8997 9.28659 11.6718 9.14602 11.5313ZM7.5007 11.2268C7.44924 11.0348 7.25183 10.9209 7.05984 10.9723C6.86781 11.0237 6.75389 11.2211 6.80531 11.4131L6.89848 11.7608C6.94994 11.9529 7.14729 12.0668 7.33934 12.0154C7.5313 11.9638 7.64531 11.7665 7.59387 11.5745L7.5007 11.2268Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const stopwatch = {
  path: () => (
    <>
      <path
        d="M10.0288 4C9.52384 4 9.1145 4.40934 9.1145 4.91428C9.1145 5.41922 9.52384 5.82855 10.0288 5.82855H13.6859C14.1908 5.82855 14.6002 5.41922 14.6002 4.91428C14.6002 4.40934 14.1908 4 13.6859 4H10.0288Z"
        fill="currentColor"
      />
      <path
        d="M16.2898 8.19632C15.8616 8.4639 15.7314 9.02795 15.999 9.45617C16.2665 9.88438 16.8306 10.0146 17.2588 9.74702L18.8095 8.77804C19.2377 8.51046 19.3679 7.94641 19.1004 7.5182C18.8328 7.08998 18.2687 6.95976 17.8405 7.22734L16.2898 8.19632Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.8572 20C15.6443 20 18.7144 16.9299 18.7144 13.1428C18.7144 9.35571 15.6443 6.28564 11.8572 6.28564C8.07006 6.28564 5 9.35571 5 13.1428C5 16.9299 8.07006 20 11.8572 20ZM11.8572 17.5313C14.2809 17.5313 16.2457 15.5664 16.2457 13.1427C16.2457 10.719 14.2809 8.7542 11.8572 8.7542C9.43348 8.7542 7.46867 10.719 7.46867 13.1427C7.46867 15.5664 9.43348 17.5313 11.8572 17.5313Z"
        fill="currentColor"
      />
      <path
        d="M15.1487 13.1428C15.1487 14.9606 13.6751 16.4342 11.8573 16.4342C10.0395 16.4342 8.56592 14.9606 8.56592 13.1428C9.11449 13.1428 11.8573 13.1428 11.8573 13.1428C11.8573 13.1428 11.8573 9.94281 11.8573 9.85138C13.6751 9.85138 15.1487 11.325 15.1487 13.1428Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const header = {
  path: () => <path d="M7 18V6H9.4828V10.9512H14.5229V6H17V18H14.5229V13.043H9.4828V18H7Z" fill="currentColor" />,
  outline: false,
};

export const timeDifference = {
  path: () => (
    <>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.4752 9.00528C15.5302 8.7133 16.6872 8.75064 17.7816 9.18797C20.4151 10.2404 21.6879 13.2069 20.6247 15.8137C19.5614 18.4206 16.5646 19.681 13.931 18.6285C12.5629 18.0818 11.5629 17.0181 11.0659 15.7572C13.1459 14.7035 14.5707 12.5631 14.5707 10.0914C14.5706 9.72104 14.5366 9.35836 14.4752 9.00528ZM17.0597 10.9583C16.7305 10.8267 16.3558 10.9841 16.2229 11.31L15.2599 13.67C15.1961 13.8264 15.1983 14.0018 15.2649 14.1571L16.27 16.4997C16.4088 16.823 16.7863 16.9739 17.113 16.8365C17.4397 16.6991 17.592 16.3254 17.4533 16.002L16.5518 13.9017L17.415 11.7866C17.5479 11.4608 17.3887 11.0899 17.0597 10.9583Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.14251 15.1806C5.30238 15.1806 3 12.9016 3 10.0903C3 7.27901 5.30238 5 8.14251 5C10.9826 5 13.285 7.27901 13.285 10.0903C13.285 12.9016 10.9826 15.1806 8.14251 15.1806ZM7.4997 7.54516C7.4997 7.19374 7.7875 6.90887 8.14251 6.90887C8.49753 6.90887 8.78533 7.19374 8.78533 7.54516V10.0903C8.78533 10.2591 8.7176 10.4209 8.59705 10.5402L6.7789 12.3399C6.52786 12.5884 6.12086 12.5884 5.86982 12.3399C5.61879 12.0915 5.61879 11.6886 5.86982 11.4401L7.4997 9.82676V7.54516Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const rulesIcon = {
  path: () => (
    <path
      d="M12.3677 7.88488C12.856 8.37309 13.649 8.37309 14.1373 7.88488C14.6256 7.39667 14.6256 6.60382 14.1373 6.11561L10.3871 2.36616C9.89882 1.87795 9.10581 1.87795 8.61751 2.36616L4.86733 6.11561C4.37902 6.60382 4.37902 7.39667 4.86733 7.88488C5.35563 8.37309 6.14864 8.37309 6.63695 7.88488L8.25031 6.27184V17.0007C8.25031 18.3794 7.12916 19.5004 5.75018 19.5004H3.25006C2.55862 19.5004 2 20.0589 2 20.7502C2 21.4415 2.55862 22 3.25006 22H5.75018C8.51204 22 10.7504 19.762 10.7504 17.0007C10.7504 15.622 11.8716 14.5011 13.2505 14.5011H17.7312L16.114 16.118C15.6257 16.6063 15.6257 17.3991 16.114 17.8873C16.6023 18.3755 17.3953 18.3755 17.8836 17.8873L21.6338 14.1379C22.1221 13.6497 22.1221 12.8568 21.6338 12.3686L17.8836 8.61915C17.3953 8.13094 16.6023 8.13094 16.114 8.61915C15.6257 9.10736 15.6257 9.90021 16.114 10.3884L17.7312 12.0015H13.2505C12.3403 12.0015 11.4848 12.2436 10.7504 12.6693V6.27184L12.3677 7.88879V7.88488Z"
      fill="currentColor"
    />
  ),
  outline: false,
};

export const keyboard = {
  path: () => (
    <path
      d="M3.44444 5C2.09618 5 1 6.09618 1 7.44444V17.2222C1 18.5705 2.09618 19.6667 3.44444 19.6667H20.5556C21.9038 19.6667 23 18.5705 23 17.2222V7.44444C23 6.09618 21.9038 5 20.5556 5H3.44444ZM4.05556 7.44444H5.27778C5.61389 7.44444 5.88889 7.71944 5.88889 8.05556V9.27778C5.88889 9.61389 5.61389 9.88889 5.27778 9.88889H4.05556C3.71944 9.88889 3.44444 9.61389 3.44444 9.27778V8.05556C3.44444 7.71944 3.71944 7.44444 4.05556 7.44444ZM3.44444 11.7222C3.44444 11.3861 3.71944 11.1111 4.05556 11.1111H5.27778C5.61389 11.1111 5.88889 11.3861 5.88889 11.7222V12.9444C5.88889 13.2806 5.61389 13.5556 5.27778 13.5556H4.05556C3.71944 13.5556 3.44444 13.2806 3.44444 12.9444V11.7222ZM4.05556 14.7778H5.27778C5.61389 14.7778 5.88889 15.0528 5.88889 15.3889V16.6111C5.88889 16.9472 5.61389 17.2222 5.27778 17.2222H4.05556C3.71944 17.2222 3.44444 16.9472 3.44444 16.6111V15.3889C3.44444 15.0528 3.71944 14.7778 4.05556 14.7778ZM7.11111 8.05556C7.11111 7.71944 7.38611 7.44444 7.72222 7.44444H8.94444C9.28056 7.44444 9.55556 7.71944 9.55556 8.05556V9.27778C9.55556 9.61389 9.28056 9.88889 8.94444 9.88889H7.72222C7.38611 9.88889 7.11111 9.61389 7.11111 9.27778V8.05556ZM7.72222 11.1111H8.94444C9.28056 11.1111 9.55556 11.3861 9.55556 11.7222V12.9444C9.55556 13.2806 9.28056 13.5556 8.94444 13.5556H7.72222C7.38611 13.5556 7.11111 13.2806 7.11111 12.9444V11.7222C7.11111 11.3861 7.38611 11.1111 7.72222 11.1111ZM7.11111 15.3889C7.11111 15.0528 7.38611 14.7778 7.72222 14.7778H16.2778C16.6139 14.7778 16.8889 15.0528 16.8889 15.3889V16.6111C16.8889 16.9472 16.6139 17.2222 16.2778 17.2222H7.72222C7.38611 17.2222 7.11111 16.9472 7.11111 16.6111V15.3889ZM11.3889 7.44444H12.6111C12.9472 7.44444 13.2222 7.71944 13.2222 8.05556V9.27778C13.2222 9.61389 12.9472 9.88889 12.6111 9.88889H11.3889C11.0528 9.88889 10.7778 9.61389 10.7778 9.27778V8.05556C10.7778 7.71944 11.0528 7.44444 11.3889 7.44444ZM10.7778 11.7222C10.7778 11.3861 11.0528 11.1111 11.3889 11.1111H12.6111C12.9472 11.1111 13.2222 11.3861 13.2222 11.7222V12.9444C13.2222 13.2806 12.9472 13.5556 12.6111 13.5556H11.3889C11.0528 13.5556 10.7778 13.2806 10.7778 12.9444V11.7222ZM15.0556 7.44444H16.2778C16.6139 7.44444 16.8889 7.71944 16.8889 8.05556V9.27778C16.8889 9.61389 16.6139 9.88889 16.2778 9.88889H15.0556C14.7194 9.88889 14.4444 9.61389 14.4444 9.27778V8.05556C14.4444 7.71944 14.7194 7.44444 15.0556 7.44444ZM14.4444 11.7222C14.4444 11.3861 14.7194 11.1111 15.0556 11.1111H16.2778C16.6139 11.1111 16.8889 11.3861 16.8889 11.7222V12.9444C16.8889 13.2806 16.6139 13.5556 16.2778 13.5556H15.0556C14.7194 13.5556 14.4444 13.2806 14.4444 12.9444V11.7222ZM18.7222 7.44444H19.9444C20.2806 7.44444 20.5556 7.71944 20.5556 8.05556V9.27778C20.5556 9.61389 20.2806 9.88889 19.9444 9.88889H18.7222C18.3861 9.88889 18.1111 9.61389 18.1111 9.27778V8.05556C18.1111 7.71944 18.3861 7.44444 18.7222 7.44444ZM18.1111 11.7222C18.1111 11.3861 18.3861 11.1111 18.7222 11.1111H19.9444C20.2806 11.1111 20.5556 11.3861 20.5556 11.7222V12.9444C20.5556 13.2806 20.2806 13.5556 19.9444 13.5556H18.7222C18.3861 13.5556 18.1111 13.2806 18.1111 12.9444V11.7222ZM18.7222 14.7778H19.9444C20.2806 14.7778 20.5556 15.0528 20.5556 15.3889V16.6111C20.5556 16.9472 20.2806 17.2222 19.9444 17.2222H18.7222C18.3861 17.2222 18.1111 16.9472 18.1111 16.6111V15.3889C18.1111 15.0528 18.3861 14.7778 18.7222 14.7778Z"
      fill="currentColor"
    />
  ),
  outline: false,
};

export const outlineExclamationCircle = {
  path: () => (
    <path
      d="M12 8V12M12 16H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  ),
  outline: true,
};

export const outlineExclamation = {
  path: () => (
    <path
      d="M12 9V11M12 15H12.01M5.07183 19H18.9282C20.4678 19 21.4301 17.3333 20.6603 16L13.7321 4C12.9623 2.66667 11.0378 2.66667 10.268 4L3.33978 16C2.56998 17.3333 3.53223 19 5.07183 19Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  ),
  outline: true,
};

export const outlineInformationCircle = {
  path: () => (
    <path
      d="M13 16H12V12H11M12 8H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  ),
  outline: true,
};

export const outlineCheckCircle = {
  path: () => (
    <path
      d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  ),
  outline: true,
};

export const paperAirplaneRight = {
  path: () => (
    <path
      d="M20.9367 13.0733C21.3432 12.8701 21.6 12.4545 21.6 12C21.6 11.5455 21.3432 11.13 20.9367 10.9267L4.13669 2.52671C3.71105 2.31389 3.19987 2.3727 2.83367 2.67661C2.46748 2.98053 2.31547 3.47212 2.44621 3.92969L4.16049 9.92967C4.30768 10.4448 4.77854 10.8 5.31432 10.8L10.8 10.8C11.4628 10.8 12 11.3373 12 12C12 12.6628 11.4628 13.2 10.8 13.2L5.31432 13.2C4.77855 13.2 4.30768 13.5552 4.1605 14.0703L2.44621 20.0704C2.31547 20.5279 2.46748 21.0195 2.83367 21.3234C3.19987 21.6273 3.71105 21.6862 4.13669 21.4733L20.9367 13.0733Z"
      fill="currentColor"
    />
  ),
  outline: false,
};

export const uploadAlt = {
  path: () => (
    <path
      d="M4 16L4 17C4 18.6569 5.34315 20 7 20L17 20C18.6569 20 20 18.6569 20 17L20 16M16 8L12 4M12 4L8 8M12 4L12 16"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  ),
  outline: true,
};

export const image = {
  path: () => (
    <path
      d="M4.85714 3H19.1429C19.9004 3.00087 20.6266 3.31722 21.1622 3.87964C21.6979 4.44206 21.9992 5.20462 22 6V18C21.9992 18.7954 21.6979 19.5579 21.1622 20.1204C20.6266 20.6828 19.9004 20.9991 19.1429 21H4.85714C4.09964 20.9991 3.37339 20.6828 2.83775 20.1204C2.30211 19.5579 2.00083 18.7954 2 18V6C2.00083 5.20462 2.30211 4.44206 2.83775 3.87964C3.37339 3.31722 4.09964 3.00087 4.85714 3ZM8.42857 6C8.00476 6 7.59046 6.13196 7.23806 6.37919C6.88567 6.62643 6.61102 6.97783 6.44883 7.38896C6.28664 7.8001 6.24421 8.2525 6.32689 8.68895C6.40957 9.12541 6.61366 9.52632 6.91334 9.84099C7.21303 10.1557 7.59485 10.37 8.01052 10.4568C8.42619 10.5436 8.85705 10.499 9.24861 10.3287C9.64016 10.1584 9.97483 9.87004 10.2103 9.50003C10.4458 9.13002 10.5714 8.69501 10.5714 8.25C10.5708 7.65345 10.3449 7.08152 9.94315 6.65969C9.54141 6.23787 8.99671 6.00062 8.42857 6ZM19.1429 19.5C19.5217 19.5 19.8851 19.342 20.153 19.0607C20.4209 18.7794 20.5714 18.3978 20.5714 18V14.8298L16.3375 10.8783C15.929 10.4979 15.3977 10.2953 14.8519 10.3119C14.3062 10.3284 13.7869 10.5628 13.4 10.9673L10.5004 14.0053L15.7335 19.5H19.1429ZM3.42857 18C3.42857 18.3978 3.57908 18.7794 3.84699 19.0607C4.1149 19.342 4.47826 19.5 4.85714 19.5H13.7129L8.29241 13.8084C7.90863 13.4657 7.42161 13.277 6.91783 13.2756C6.41404 13.2742 5.92609 13.4603 5.54062 13.8009L3.42857 15.6488V18Z"
      fill="currentColor"
    />
  ),
  outline: false,
};

export const eyedropper = {
  path: () => (
    <path
      d="M14.675 4.9125L11.5031 8.0875L11.2094 7.79375C10.8188 7.40312 10.1844 7.40312 9.79377 7.79375C9.40315 8.18437 9.40315 8.81875 9.79377 9.20937L14.7938 14.2094C15.1844 14.6 15.8188 14.6 16.2094 14.2094C16.6 13.8187 16.6 13.1844 16.2094 12.7937L15.9156 12.5L19.0875 9.325C20.3063 8.10625 20.3063 6.13125 19.0875 4.91562C17.8688 3.7 15.8938 3.69687 14.6781 4.91562L14.675 4.9125ZM5.73127 14.1031C5.26252 14.5719 5.00002 15.2094 5.00002 15.8719V17.1969L4.16877 18.4437C3.90315 18.8406 3.95627 19.3687 4.29377 19.7062C4.63127 20.0437 5.1594 20.0969 5.55627 19.8312L6.80315 19H8.12815C8.79065 19 9.42815 18.7375 9.8969 18.2687L13.6688 14.4969L12.2531 13.0812L8.48127 16.8531C8.38752 16.9469 8.2594 17 8.12815 17H7.00002V15.8719C7.00002 15.7406 7.05315 15.6125 7.1469 15.5187L10.9188 11.7469L9.50315 10.3312L5.73127 14.1031Z"
      fill="currentColor"
    />
  ),
  outline: false,
};

export const textColor = {
  path: () => (
    <>
      <path
        d="M6.17769 12.1044H4.46143L7.58625 3.375H9.57123L12.7004 12.1044H10.9841L8.61341 5.16521H8.54407L6.17769 12.1044ZM6.23404 8.68169H10.9148V9.95189H6.23404V8.68169Z"
        fill="currentColor"
      />
      <path
        d="M15.7158 12.2365C15.2939 12.2365 14.914 12.1627 14.5759 12.0149C14.2408 11.8643 13.9749 11.6426 13.7785 11.35C13.5849 11.0573 13.4881 10.6964 13.4881 10.2673C13.4881 9.8979 13.5574 9.59243 13.6961 9.35089C13.8348 9.10935 14.0241 8.91613 14.2639 8.7712C14.5037 8.62628 14.7738 8.51688 15.0743 8.443C15.3777 8.36628 15.6912 8.31086 16.0148 8.27676C16.4049 8.23698 16.7213 8.20146 16.964 8.17021C17.2067 8.13611 17.3829 8.08496 17.4927 8.01676C17.6054 7.94572 17.6617 7.83632 17.6617 7.68855V7.66298C17.6617 7.34188 17.565 7.09324 17.3714 6.91706C17.1778 6.74088 16.899 6.65279 16.5349 6.65279C16.1506 6.65279 15.8458 6.7352 15.6204 6.90001C15.3979 7.06482 15.2477 7.25947 15.1697 7.48396L13.7048 7.27936C13.8204 6.88154 14.0111 6.54907 14.2769 6.28196C14.5427 6.01201 14.8678 5.81025 15.252 5.6767C15.6363 5.5403 16.061 5.4721 16.5262 5.4721C16.847 5.4721 17.1662 5.50904 17.484 5.58293C17.8019 5.65681 18.0923 5.779 18.3552 5.94949C18.6181 6.11715 18.829 6.3459 18.988 6.63574C19.1498 6.92558 19.2307 7.28789 19.2307 7.72265V12.1044H17.7224V11.205H17.6704C17.5751 11.3869 17.4407 11.5574 17.2674 11.7165C17.0969 11.8728 16.8816 11.9993 16.6216 12.0959C16.3644 12.1897 16.0625 12.2365 15.7158 12.2365ZM16.1232 11.1027C16.4381 11.1027 16.7112 11.0416 16.9423 10.9195C17.1734 10.7944 17.3511 10.6296 17.4754 10.425C17.6025 10.2204 17.6661 9.99736 17.6661 9.75582V8.98432C17.617 9.02411 17.5332 9.06105 17.4147 9.09515C17.2991 9.12925 17.1691 9.15908 17.0246 9.18466C16.8802 9.21023 16.7372 9.23296 16.5956 9.25286C16.454 9.27275 16.3312 9.2898 16.2272 9.304C15.9932 9.33526 15.7837 9.38641 15.5988 9.45745C15.4138 9.52849 15.2679 9.62795 15.161 9.75582C15.0541 9.88085 15.0007 10.0428 15.0007 10.2417C15.0007 10.5259 15.1061 10.7404 15.317 10.8854C15.528 11.0303 15.7967 11.1027 16.1232 11.1027Z"
        fill="currentColor"
      />
      <g clip-path="url(#clip0_4355_55050)">
        <rect x="2" y="14.4519" width="4.92308" height="4.92308" fill="#8B5CF6" />
        <rect x="6.9231" y="14.4519" width="4.92308" height="4.92308" fill="#649B6F" />
        <rect x="11.8462" y="14.4519" width="4.92308" height="4.92308" fill="#F59E0B" />
        <rect x="16.7693" y="14.4519" width="4.92308" height="4.92308" fill="#EF4444" />
      </g>
      <defs>
        <clipPath id="clip0_4355_55050">
          <rect x="2" y="14.4519" width="19.6923" height="4.92308" rx="0.625" fill="white" />
        </clipPath>
      </defs>
    </>
  ),
  outline: false,
};

export const textBackground = {
  path: () => (
    <>
      <rect x="2" y="2" width="20" height="20" rx="2" fill="currentColor" />
      <path
        d="M6.24309 16.3658H4.5L7.67365 7.5H9.68964L12.8677 16.3658H11.1246L8.71686 9.31818H8.64643L6.24309 16.3658ZM6.30031 12.8896H11.0542V14.1797H6.30031V12.8896Z"
        fill="white"
      />
      <path
        d="M15.9302 16.5C15.5018 16.5 15.1159 16.425 14.7725 16.2749C14.4321 16.1219 14.1622 15.8968 13.9626 15.5996C13.766 15.3023 13.6677 14.9358 13.6677 14.5C13.6677 14.1248 13.7381 13.8146 13.879 13.5693C14.0198 13.324 14.2121 13.1277 14.4556 12.9805C14.6992 12.8333 14.9736 12.7222 15.2787 12.6472C15.5869 12.5693 15.9053 12.513 16.2339 12.4784C16.6301 12.438 16.9514 12.4019 17.1979 12.3701C17.4444 12.3355 17.6234 12.2835 17.7349 12.2143C17.8494 12.1421 17.9066 12.031 17.9066 11.881V11.855C17.9066 11.5289 17.8083 11.2763 17.6117 11.0974C17.415 10.9185 17.1319 10.829 16.7621 10.829C16.3718 10.829 16.0622 10.9127 15.8334 11.0801C15.6074 11.2475 15.4548 11.4452 15.3756 11.6732L13.8878 11.4654C14.0052 11.0613 14.1988 10.7237 14.4688 10.4524C14.7388 10.1782 15.0689 9.9733 15.4592 9.83766C15.8495 9.69913 16.2809 9.62987 16.7533 9.62987C17.079 9.62987 17.4033 9.66739 17.7261 9.74242C18.0489 9.81746 18.3438 9.94156 18.6109 10.1147C18.8779 10.285 19.0921 10.5173 19.2535 10.8117C19.4178 11.1061 19.5 11.474 19.5 11.9156V16.3658H17.9682V15.4524H17.9154C17.8185 15.6371 17.6821 15.8102 17.506 15.9719C17.3329 16.1306 17.1143 16.259 16.8502 16.3571C16.589 16.4524 16.2823 16.5 15.9302 16.5ZM16.344 15.3485C16.6638 15.3485 16.9411 15.2864 17.1759 15.1623C17.4106 15.0354 17.5911 14.868 17.7173 14.6602C17.8464 14.4524 17.911 14.2258 17.911 13.9805V13.197C17.8611 13.2374 17.776 13.2749 17.6557 13.3095C17.5383 13.3442 17.4062 13.3745 17.2595 13.4004C17.1128 13.4264 16.9675 13.4495 16.8237 13.4697C16.68 13.4899 16.5552 13.5072 16.4496 13.5216C16.2119 13.5534 15.9992 13.6053 15.8113 13.6775C15.6235 13.7496 15.4754 13.8506 15.3668 13.9805C15.2582 14.1075 15.2039 14.272 15.2039 14.474C15.2039 14.7626 15.311 14.9805 15.5252 15.1277C15.7395 15.2749 16.0124 15.3485 16.344 15.3485Z"
        fill="white"
      />
    </>
  ),
  outline: false,
};

export const strikethrough = {
  path: () => (
    <>
      <path d="M4 10.5911H20V12.1163H4V10.5911Z" fill="currentColor" />
      <path
        d="M14.1339 6.6237C14.7204 7.01801 15.054 7.57409 15.1349 8.29194H17.3946C17.3744 7.45782 17.1317 6.71975 16.6666 6.07772C16.2016 5.43065 15.5646 4.92259 14.7557 4.55355C13.9519 4.18452 13.0243 4 11.9728 4C10.9314 4 9.99618 4.18705 9.16711 4.56114C8.33804 4.93017 7.68086 5.44834 7.19555 6.11564C6.71024 6.78294 6.46759 7.56398 6.46759 8.45877C6.46759 9.5406 6.82904 10.4101 7.55195 11.0673C8.00873 11.4797 8.56702 11.8293 9.22682 12.1163H15.7166C15.3851 11.9029 15.0345 11.7225 14.6647 11.5754C14.144 11.3681 13.636 11.2038 13.1406 11.0825L11.624 10.6882C11.3207 10.6123 11.0047 10.5163 10.6761 10.4C10.3475 10.2787 10.0392 10.1295 9.751 9.95261C9.4679 9.77062 9.23789 9.54566 9.06095 9.27773C8.88907 9.00979 8.80313 8.69131 8.80313 8.32228C8.80313 7.88246 8.92951 7.49068 9.18228 7.14692C9.4401 6.7981 9.80155 6.52512 10.2666 6.32796C10.7317 6.12575 11.2828 6.02465 11.9197 6.02465C12.8095 6.02465 13.5475 6.22433 14.1339 6.6237Z"
        fill="currentColor"
      />
      <path
        d="M17.1836 13.6416H13.9955C14.3667 13.8212 14.6656 14.0399 14.8922 14.2976C15.1551 14.5908 15.2865 14.9675 15.2865 15.4275C15.2865 15.933 15.1374 16.3754 14.8391 16.7545C14.5409 17.1286 14.1314 17.4218 13.6107 17.6341C13.0951 17.8414 12.5061 17.945 11.8439 17.945C11.2423 17.945 10.6888 17.8566 10.1832 17.6796C9.68275 17.4976 9.27075 17.2221 8.94721 16.8531C8.62872 16.479 8.44673 16.0114 8.40124 15.4502H6.05052C6.10108 16.3855 6.36648 17.1943 6.84673 17.8768C7.32699 18.5542 7.99176 19.0774 8.84105 19.4464C9.69033 19.8155 10.6963 20 11.8591 20C13.0723 20 14.1061 19.8028 14.9605 19.4085C15.8199 19.0142 16.4745 18.4758 16.9245 17.7934C17.3794 17.1109 17.6069 16.3299 17.6069 15.4502C17.6069 14.7526 17.4679 14.1536 17.1899 13.6531C17.1878 13.6492 17.1857 13.6454 17.1836 13.6416Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const lineHeight = {
  path: () => (
    <>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.8001 5.99999C10.8001 5.33725 11.3374 4.79999 12.0001 4.79999H19.2001C19.8628 4.79999 20.4001 5.33725 20.4001 5.99999C20.4001 6.66273 19.8628 7.19999 19.2001 7.19999H12.0001C11.3374 7.19999 10.8001 6.66273 10.8001 5.99999Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.8001 12C10.8001 11.3372 11.3374 10.8 12.0001 10.8H19.2001C19.8628 10.8 20.4001 11.3372 20.4001 12C20.4001 12.6627 19.8628 13.2 19.2001 13.2H12.0001C11.3374 13.2 10.8001 12.6627 10.8001 12Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.8001 18C10.8001 17.3372 11.3374 16.8 12.0001 16.8H19.2001C19.8628 16.8 20.4001 17.3372 20.4001 18C20.4001 18.6627 19.8628 19.2 19.2001 19.2H12.0001C11.3374 19.2 10.8001 18.6627 10.8001 18Z"
        fill="currentColor"
      />
      <path
        d="M6.22168 7.28196L8.28052 9.04667C8.52052 9.25239 8.37504 9.64567 8.05893 9.64567L3.94127 9.64567C3.62516 9.64567 3.47967 9.25239 3.71968 9.04667L5.77851 7.28196C5.90602 7.17266 6.09418 7.17266 6.22168 7.28196Z"
        fill="currentColor"
      />
      <path
        d="M5.77851 16.7637L3.71968 14.999C3.47967 14.7933 3.62516 14.4 3.94127 14.4H8.05893C8.37504 14.4 8.52052 14.7933 8.28051 14.999L6.22168 16.7637C6.09417 16.873 5.90602 16.873 5.77851 16.7637Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const outdent = {
  path: () => (
    <>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.6001 5.99999C3.6001 5.33725 4.13736 4.79999 4.8001 4.79999H19.2001C19.8628 4.79999 20.4001 5.33725 20.4001 5.99999C20.4001 6.66273 19.8628 7.19999 19.2001 7.19999H4.8001C4.13736 7.19999 3.6001 6.66273 3.6001 5.99999Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.8001 12C10.8001 11.3372 11.3374 10.8 12.0001 10.8H19.2001C19.8628 10.8 20.4001 11.3372 20.4001 12C20.4001 12.6627 19.8628 13.2 19.2001 13.2H12.0001C11.3374 13.2 10.8001 12.6627 10.8001 12Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.8001 18C10.8001 17.3372 11.3374 16.8 12.0001 16.8H19.2001C19.8628 16.8 20.4001 17.3372 20.4001 18C20.4001 18.6627 19.8628 19.2 19.2001 19.2H12.0001C11.3374 19.2 10.8001 18.6627 10.8001 18Z"
        fill="currentColor"
      />
      <path
        d="M3.86785 14.6876L6.35565 11.7852C6.64567 11.4468 7.2001 11.6519 7.2001 12.0976V17.9024C7.2001 18.3481 6.64567 18.5532 6.35565 18.2148L3.86785 15.3124C3.71378 15.1326 3.71378 14.8674 3.86785 14.6876Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const indent = {
  path: () => (
    <>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.6001 5.99999C3.6001 5.33725 4.13736 4.79999 4.8001 4.79999H19.2001C19.8628 4.79999 20.4001 5.33725 20.4001 5.99999C20.4001 6.66273 19.8628 7.19999 19.2001 7.19999H4.8001C4.13736 7.19999 3.6001 6.66273 3.6001 5.99999Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.8001 12C10.8001 11.3372 11.3374 10.8 12.0001 10.8H19.2001C19.8628 10.8 20.4001 11.3372 20.4001 12C20.4001 12.6627 19.8628 13.2 19.2001 13.2H12.0001C11.3374 13.2 10.8001 12.6627 10.8001 12Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.8001 18C10.8001 17.3372 11.3374 16.8 12.0001 16.8H19.2001C19.8628 16.8 20.4001 17.3372 20.4001 18C20.4001 18.6627 19.8628 19.2 19.2001 19.2H12.0001C11.3374 19.2 10.8001 18.6627 10.8001 18Z"
        fill="currentColor"
      />
      <path
        d="M6.93234 15.3124L4.44454 18.2148C4.15453 18.5532 3.6001 18.3481 3.6001 17.9024L3.6001 12.0976C3.6001 11.6519 4.15453 11.4468 4.44454 11.7852L6.93234 14.6876C7.08642 14.8674 7.08642 15.1326 6.93234 15.3124Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const centerAlignedText = {
  path: () => (
    <>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.0001 5.99999C6.0001 5.33725 6.53736 4.79999 7.2001 4.79999L16.8001 4.79999C17.4628 4.79999 18.0001 5.33725 18.0001 5.99999C18.0001 6.66273 17.4628 7.19999 16.8001 7.19999H7.2001C6.53736 7.19999 6.0001 6.66273 6.0001 5.99999Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.6001 12C3.6001 11.3372 4.13736 10.8 4.8001 10.8H19.2001C19.8628 10.8 20.4001 11.3372 20.4001 12C20.4001 12.6627 19.8628 13.2 19.2001 13.2H4.8001C4.13736 13.2 3.6001 12.6627 3.6001 12Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.0001 18C6.0001 17.3372 6.53736 16.8 7.2001 16.8H16.8001C17.4628 16.8 18.0001 17.3372 18.0001 18C18.0001 18.6627 17.4628 19.2 16.8001 19.2H7.2001C6.53736 19.2 6.0001 18.6627 6.0001 18Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const unlink = {
  path: () => (
    <path
      d="M13.5026 16.6846C13.6491 16.831 13.6491 17.0685 13.5026 17.2149L12.1066 18.611C10.2546 20.4629 7.24115 20.4631 5.38902 18.611C3.53702 16.759 3.53702 13.7455 5.38902 11.8935L6.78512 10.4974C6.93155 10.351 7.16899 10.351 7.31546 10.4974L8.5529 11.7348C8.69934 11.8813 8.69934 12.1187 8.5529 12.2652L7.1568 13.6612C6.27955 14.5385 6.27955 15.9659 7.1568 16.8432C8.03405 17.7205 9.46149 17.7205 10.3388 16.8432L11.7349 15.4471C11.8813 15.3007 12.1187 15.3007 12.2652 15.4471L13.5026 16.6846ZM11.7349 8.55284C11.8813 8.69927 12.1187 8.69927 12.2652 8.55284L13.6613 7.15677C14.5385 6.27943 15.966 6.27949 16.8433 7.15677C17.7205 8.03406 17.7205 9.46146 16.8433 10.3387L15.4472 11.7348C15.3007 11.8812 15.3007 12.1187 15.4472 12.2651L16.6846 13.5026C16.8311 13.649 17.0685 13.649 17.215 13.5026L18.6111 12.1065C20.4631 10.2545 20.4631 7.24102 18.6111 5.38899C16.759 3.53699 13.7456 3.53699 11.8935 5.38899L10.4975 6.78506C10.351 6.93149 10.351 7.16893 10.4975 7.3154L11.7349 8.55284ZM19.0732 19.7803L19.7803 19.0732C20.0732 18.7803 20.0732 18.3055 19.7803 18.0126L5.98746 4.21965C5.69455 3.92674 5.21968 3.92674 4.9268 4.21965L4.21968 4.92677C3.92677 5.21968 3.92677 5.69456 4.21968 5.98743L18.0126 19.7803C18.3055 20.0732 18.7804 20.0732 19.0732 19.7803Z"
      fill="currentColor"
    />
  ),
  outline: false,
};

export const oneDriveLogo = {
  path: () => (
    <>
      <g clip-path="url(#clip0_483_13023)">
        <path
          d="M9.152 8.58044L14.1905 11.5975L17.1927 10.3341C17.8027 10.0703 18.4605 9.9351 19.1252 9.93575C19.2359 9.93575 19.3453 9.94078 19.4542 9.94805C19.0933 8.54061 18.3313 7.26831 17.2609 6.28575C16.1905 5.3032 14.8578 4.65269 13.4247 4.41328C11.9915 4.17387 10.5197 4.35587 9.1881 4.93716C7.85646 5.51845 6.72232 6.474 5.9235 7.68769C5.94917 7.68737 5.97444 7.68576 6.00017 7.68576C7.11365 7.68425 8.20537 7.99415 9.152 8.58044Z"
          fill="#0364B8"
        />
        <path
          d="M9.152 8.58044C8.20537 7.99415 7.11365 7.68425 6.00017 7.68576C5.97444 7.68576 5.94917 7.68737 5.9235 7.68769C4.83368 7.70118 3.76795 8.0114 2.84119 8.58499C1.91443 9.15859 1.16149 9.97387 0.663277 10.9432C0.165068 11.9126 -0.0595726 12.9994 0.0134948 14.0869C0.0865622 15.1743 0.454576 16.2213 1.07799 17.1153L14.1905 11.5975L9.152 8.58044Z"
          fill="#0078D4"
        />
        <path
          d="M19.4542 9.94805C19.3453 9.94078 19.2359 9.93575 19.1252 9.93575C18.4605 9.9351 17.8027 10.0703 17.1927 10.3341L14.1905 11.5975L23.417 17.1241C23.8038 16.406 24.0043 15.6023 24 14.7866C23.9958 13.9709 23.7869 13.1694 23.3926 12.4554C22.9983 11.7413 22.4311 11.1376 21.7431 10.6996C21.055 10.2615 20.2681 10.0031 19.4542 9.94805Z"
          fill="#1490DF"
        />
        <path
          d="M14.1904 11.6009L1.07813 17.1188C1.63025 17.9126 2.36629 18.561 3.22339 19.0086C4.08049 19.4562 5.03318 19.6897 6.00012 19.6892H19.1251C20.0051 19.6895 20.8688 19.4515 21.6244 19.0005C22.3801 18.5494 22.9995 17.9022 23.417 17.1275L14.1904 11.6009Z"
          fill="#28A8EA"
        />
      </g>
      <defs>
        <clipPath id="clip0_483_13023">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </>
  ),
  outline: false,
};

export const googleSheetsLogo = {
  path: () => (
    <>
      <mask
        id="mask0_483_13067"
        style={{ "mask-type": "alpha" }}
        maskUnits="userSpaceOnUse"
        x="3"
        y="0"
        width="18"
        height="24"
      >
        <path
          d="M14.1818 0H4.90907C4.00907 0 3.27271 0.736364 3.27271 1.63636V22.3636C3.27271 23.2636 4.00907 24 4.90907 24H19.0909C19.9909 24 20.7272 23.2636 20.7272 22.3636V6.54545L14.1818 0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_483_13067)">
        <path
          d="M14.1818 0H4.90907C4.00907 0 3.27271 0.736364 3.27271 1.63636V22.3636C3.27271 23.2636 4.00907 24 4.90907 24H19.0909C19.9909 24 20.7272 23.2636 20.7272 22.3636V6.54545L16.9091 3.81818L14.1818 0Z"
          fill="#0F9D58"
        />
      </g>
      <mask
        id="mask1_483_13067"
        style={{ "mask-type": "alpha" }}
        maskUnits="userSpaceOnUse"
        x="3"
        y="0"
        width="18"
        height="24"
      >
        <path
          d="M14.1818 0H4.90907C4.00907 0 3.27271 0.736364 3.27271 1.63636V22.3636C3.27271 23.2636 4.00907 24 4.90907 24H19.0909C19.9909 24 20.7272 23.2636 20.7272 22.3636V6.54545L14.1818 0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_483_13067)">
        <path
          d="M7.6366 11.7273V19.6364H16.3639V11.7273H7.6366ZM11.4548 18.5454H8.72751V17.1818H11.4548V18.5454ZM11.4548 16.3636H8.72751V15H11.4548V16.3636ZM11.4548 14.1818H8.72751V12.8182H11.4548V14.1818ZM15.273 18.5454H12.5457V17.1818H15.273V18.5454ZM15.273 16.3636H12.5457V15H15.273V16.3636ZM15.273 14.1818H12.5457V12.8182H15.273V14.1818Z"
          fill="#F1F1F1"
        />
      </g>
      <mask
        id="mask2_483_13067"
        style={{ "mask-type": "alpha" }}
        maskUnits="userSpaceOnUse"
        x="3"
        y="0"
        width="18"
        height="24"
      >
        <path
          d="M14.1818 0H4.90907C4.00907 0 3.27271 0.736364 3.27271 1.63636V22.3636C3.27271 23.2636 4.00907 24 4.90907 24H19.0909C19.9909 24 20.7272 23.2636 20.7272 22.3636V6.54545L14.1818 0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask2_483_13067)">
        <path d="M14.66 6.06644L20.7269 12.1319V6.54507L14.66 6.06644Z" fill="url(#paint0_linear_483_13067)" />
      </g>
      <mask
        id="mask3_483_13067"
        style={{ "mask-type": "alpha" }}
        maskUnits="userSpaceOnUse"
        x="3"
        y="0"
        width="18"
        height="24"
      >
        <path
          d="M14.1818 0H4.90907C4.00907 0 3.27271 0.736364 3.27271 1.63636V22.3636C3.27271 23.2636 4.00907 24 4.90907 24H19.0909C19.9909 24 20.7272 23.2636 20.7272 22.3636V6.54545L14.1818 0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask3_483_13067)">
        <path
          d="M14.1819 0V4.90909C14.1819 5.81318 14.9142 6.54545 15.8182 6.54545H20.7273L14.1819 0Z"
          fill="#87CEAC"
        />
      </g>
      <mask
        id="mask4_483_13067"
        style={{ "mask-type": "alpha" }}
        maskUnits="userSpaceOnUse"
        x="3"
        y="0"
        width="18"
        height="24"
      >
        <path
          d="M14.1818 0H4.90907C4.00907 0 3.27271 0.736364 3.27271 1.63636V22.3636C3.27271 23.2636 4.00907 24 4.90907 24H19.0909C19.9909 24 20.7272 23.2636 20.7272 22.3636V6.54545L14.1818 0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask4_483_13067)">
        <path
          d="M4.90907 0C4.00907 0 3.27271 0.736363 3.27271 1.63636V1.77273C3.27271 0.872727 4.00907 0.136364 4.90907 0.136364H14.1818V0H4.90907Z"
          fill="white"
          fill-opacity="0.2"
        />
      </g>
      <mask
        id="mask5_483_13067"
        style={{ "mask-type": "alpha" }}
        maskUnits="userSpaceOnUse"
        x="3"
        y="0"
        width="18"
        height="24"
      >
        <path
          d="M14.1818 0H4.90907C4.00907 0 3.27271 0.736364 3.27271 1.63636V22.3636C3.27271 23.2636 4.00907 24 4.90907 24H19.0909C19.9909 24 20.7272 23.2636 20.7272 22.3636V6.54545L14.1818 0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask5_483_13067)">
        <path
          d="M19.0909 23.8636H4.90907C4.00907 23.8636 3.27271 23.1273 3.27271 22.2273V22.3636C3.27271 23.2636 4.00907 24 4.90907 24H19.0909C19.9909 24 20.7272 23.2636 20.7272 22.3636V22.2273C20.7272 23.1273 19.9909 23.8636 19.0909 23.8636Z"
          fill="#263238"
          fill-opacity="0.2"
        />
      </g>
      <mask
        id="mask6_483_13067"
        style={{ "mask-type": "alpha" }}
        maskUnits="userSpaceOnUse"
        x="3"
        y="0"
        width="18"
        height="24"
      >
        <path
          d="M14.1818 0H4.90907C4.00907 0 3.27271 0.736364 3.27271 1.63636V22.3636C3.27271 23.2636 4.00907 24 4.90907 24H19.0909C19.9909 24 20.7272 23.2636 20.7272 22.3636V6.54545L14.1818 0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask6_483_13067)">
        <path
          d="M15.8182 6.54713C14.9142 6.54713 14.1819 5.81486 14.1819 4.91077V5.04713C14.1819 5.95122 14.9142 6.68349 15.8182 6.68349H20.7273V6.54713H15.8182Z"
          fill="#263238"
          fill-opacity="0.1"
        />
      </g>
      <path
        d="M14.1818 0H4.90907C4.00907 0 3.27271 0.736364 3.27271 1.63636V22.3636C3.27271 23.2636 4.00907 24 4.90907 24H19.0909C19.9909 24 20.7272 23.2636 20.7272 22.3636V6.54545L14.1818 0Z"
        fill="url(#paint1_radial_483_13067)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_483_13067"
          x1="17.6938"
          y1="6.58722"
          x2="17.6938"
          y2="12.1327"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#263238" stop-opacity="0.2" />
          <stop offset="1" stop-color="#263238" stop-opacity="0.02" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_483_13067"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(3.82567 0.47705) scale(28.1452 28.1452)"
        >
          <stop stop-color="white" stop-opacity="0.1" />
          <stop offset="1" stop-color="white" stop-opacity="0" />
        </radialGradient>
      </defs>
    </>
  ),
  outline: false,
};

export const wordLogo = {
  path: () => (
    <>
      <g clip-path="url(#clip0_483_13117)">
        <path
          d="M22.977 0.86618H6.60496C6.03994 0.86618 5.58191 1.32303 5.58191 1.88659V6.43306L15.0701 9.2165L24.0001 6.43306V1.88659C24.0001 1.32303 23.542 0.86618 22.977 0.86618Z"
          fill="#41A5EE"
        />
        <path d="M24.0001 6.4325H5.58191V11.9994L15.0701 13.6694L24.0001 11.9994V6.4325Z" fill="#2B7CD3" />
        <path d="M5.58191 12.0007V17.5676L14.5119 18.681L24.0001 17.5676V12.0007H5.58191Z" fill="#185ABD" />
        <path
          d="M6.60496 23.1338H22.977C23.5421 23.1338 24.0001 22.677 24.0001 22.1134V17.5669H5.58191V22.1134C5.58191 22.677 6.03994 23.1338 6.60496 23.1338Z"
          fill="#103F91"
        />
        <path
          opacity="0.1"
          d="M12.3726 5.31924H5.58191V19.2364H12.3726C12.9369 19.2346 13.3938 18.7788 13.3957 18.216V6.33966C13.3938 5.77686 12.9369 5.32108 12.3726 5.31924Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M11.8145 5.87585H5.58191V19.7931H11.8145C12.3788 19.7912 12.8357 19.3354 12.8376 18.7726V6.89627C12.8357 6.33347 12.3788 5.87769 11.8145 5.87585Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M11.8145 5.87585H5.58191V18.6797H11.8145C12.3788 18.6778 12.8357 18.2221 12.8376 17.6593V6.89627C12.8357 6.33347 12.3788 5.87769 11.8145 5.87585Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M11.2564 5.87585H5.58191V18.6797H11.2564C11.8206 18.6778 12.2776 18.2221 12.2794 17.6593V6.89627C12.2776 6.33347 11.8206 5.87769 11.2564 5.87585Z"
          fill="black"
        />
        <path
          d="M1.02305 5.87585H11.2557C11.8207 5.87585 12.2788 6.33271 12.2788 6.89627V17.1026C12.2788 17.6661 11.8207 18.123 11.2557 18.123H1.02305C0.458033 18.123 0 17.6661 0 17.1026V6.89627C0 6.33271 0.458033 5.87585 1.02305 5.87585Z"
          fill="#2368C4"
        />
        <path
          d="M4.19821 13.7018C4.2183 13.8593 4.2317 13.9963 4.23783 14.1138H4.26127C4.2702 14.0024 4.2888 13.8683 4.31708 13.7113C4.34536 13.5543 4.37085 13.4216 4.39355 13.3132L5.46962 8.68271H6.86103L7.97728 13.2437C8.04214 13.5273 8.08856 13.8147 8.11626 14.1043H8.13468C8.15549 13.8238 8.19427 13.5449 8.25077 13.2693L9.14098 8.68048H10.4074L8.84349 15.3162H7.3639L6.30346 10.9217C6.27277 10.7953 6.23761 10.63 6.1991 10.4268C6.16058 10.2236 6.13659 10.075 6.12709 9.98145H6.10867C6.0964 10.0894 6.07239 10.2498 6.03667 10.4624C6.00095 10.6751 5.9723 10.8324 5.95071 10.9345L4.95389 15.3151H3.44919L1.87695 8.68269H3.16622L4.13569 13.3227C4.15746 13.4179 4.17812 13.5448 4.19821 13.7018Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_483_13117">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </>
  ),
  outline: false,
};

export const mongoDBLogo = {
  path: () => (
    <path
      d="M14.0938 2.67497C13.0821 1.47987 12.2109 0.266096 12.0329 0.014005C12.0142 -0.00466834 11.9861 -0.00466834 11.9673 0.014005C11.7893 0.266096 10.9181 1.47987 9.90638 2.67497C1.22236 13.7016 11.2741 21.143 11.2741 21.143L11.3584 21.199C11.4333 22.3474 11.6207 24 11.6207 24H11.9954H12.3701C12.3701 24 12.5575 22.3567 12.6324 21.199L12.7167 21.1337C12.7261 21.1337 22.7778 13.7016 14.0938 2.67497ZM11.9954 20.9749C11.9954 20.9749 11.5458 20.5921 11.424 20.396V20.3774L11.9673 8.37035C11.9673 8.33301 12.0235 8.33301 12.0235 8.37035L12.5669 20.3774V20.396C12.4451 20.5921 11.9954 20.9749 11.9954 20.9749Z"
      fill="#00684A"
    />
  ),
  outline: false,
};

export const excelLogo = {
  path: () => (
    <>
      <g clip-path="url(#clip0_483_13142)">
        <g clip-path="url(#clip1_483_13142)">
          <path
            d="M15.0698 11.4429L5.58142 9.77142V22.1216C5.58142 22.6856 6.03946 23.1429 6.60449 23.1429H22.977C23.542 23.1429 24 22.6856 24 22.1216V17.5714L15.0698 11.4429Z"
            fill="#185C37"
          />
          <path
            d="M15.0698 0.857147H6.60449C6.03946 0.857147 5.58142 1.31437 5.58142 1.87839V6.42858L15.0698 12L20.093 13.6714L24 12V6.42858L15.0698 0.857147Z"
            fill="#21A366"
          />
          <path d="M5.58142 6.42859H15.0698V12H5.58142V6.42859Z" fill="#107C41" />
          <path
            opacity="0.1"
            d="M12.3723 5.3143H5.58142V19.2429H12.3723C12.9366 19.241 13.3935 18.7849 13.3954 18.2216V6.33554C13.3935 5.77229 12.9366 5.31613 12.3723 5.3143Z"
            fill="black"
          />
          <path
            opacity="0.2"
            d="M11.8142 5.87143H5.58142V19.8H11.8142C12.3784 19.7982 12.8354 19.342 12.8372 18.7788V6.89267C12.8354 6.32942 12.3784 5.87326 11.8142 5.87143Z"
            fill="black"
          />
          <path
            opacity="0.2"
            d="M11.8142 5.87143H5.58142V18.6857H11.8142C12.3784 18.6839 12.8354 18.2277 12.8372 17.6645V6.89267C12.8354 6.32942 12.3784 5.87326 11.8142 5.87143Z"
            fill="black"
          />
          <path
            opacity="0.2"
            d="M11.256 5.87143H5.58142V18.6857H11.256C11.8203 18.6839 12.2773 18.2277 12.2791 17.6645V6.89267C12.2773 6.32942 11.8203 5.87326 11.256 5.87143Z"
            fill="black"
          />
          <path
            d="M1.02307 5.87143H11.256C11.821 5.87143 12.2791 6.32865 12.2791 6.89267V17.1073C12.2791 17.6713 11.821 18.1286 11.256 18.1286H1.02307C0.458041 18.1286 0 17.6713 0 17.1073V6.89267C0 6.32865 0.458041 5.87143 1.02307 5.87143Z"
            fill="#18884F"
          />
          <path
            d="M3.16858 15.3195L5.32077 11.9905L3.34886 8.67999H4.93509L6.01118 10.7971C6.11054 10.9983 6.17862 11.1476 6.21547 11.2462H6.22942C6.30011 11.0857 6.37453 10.9299 6.45267 10.7787L7.603 8.68111H9.05918L7.03704 11.9722L9.11054 15.3195H7.56114L6.31816 12.9956C6.25961 12.8968 6.20993 12.7929 6.1697 12.6853H6.15129C6.11488 12.7907 6.06657 12.8916 6.00728 12.9862L4.72747 15.3195H3.16858Z"
            fill="white"
          />
          <path
            d="M22.977 0.857147H15.0698V6.42858H24.0001V1.87839C24.0001 1.31437 23.542 0.857147 22.977 0.857147Z"
            fill="#33C481"
          />
          <path d="M15.0698 12H24.0001V17.5714H15.0698V12Z" fill="#107C41" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_483_13142">
          <rect width="24" height="24" fill="white" />
        </clipPath>
        <clipPath id="clip1_483_13142">
          <rect width="24" height="22.2857" fill="white" transform="translate(0 0.857147)" />
        </clipPath>
      </defs>
    </>
  ),
  outline: false,
};

export const webDAVLogo = {
  path: () => (
    <>
      <path
        d="M11.712 4.84399C9.99124 5.2257 8.59767 6.11637 7.57371 7.4857C7.13746 8.07342 6.67092 9.0065 6.48915 9.67905L6.3498 10.1759L6.04685 10.2183C5.35613 10.3092 4.63511 10.6303 3.97468 11.1332C2.23576 12.448 1.67227 14.8413 2.64777 16.7741L2.86589 17.2043L1.42992 18.2222L0 19.2401L1.66016 19.2583C2.57506 19.2643 6.94963 19.2643 11.3787 19.2583L19.4372 19.2401L19.9219 19.1007C21.0913 18.7736 22.0728 18.1313 22.806 17.2225C23.2119 16.7196 23.7087 15.7441 23.8602 15.1503C24.0177 14.5383 24.048 13.3993 23.9208 12.7812C23.4785 10.5939 21.8123 8.92167 19.6008 8.44907C19.1463 8.35213 19.0857 8.32184 19.0009 8.15824C18.6313 7.43723 17.6377 6.34055 16.9106 5.8619C16.3713 5.51048 15.4928 5.11058 14.8626 4.93487C14.0629 4.71675 12.4936 4.66828 11.712 4.84399ZM16.7349 9.98199C16.7652 10.1092 16.8682 10.5334 16.959 10.9211C17.0499 11.315 17.1469 11.6361 17.1711 11.6361C17.2135 11.6361 18.5404 10.9333 18.8373 10.7515C18.91 10.7091 19.0009 10.5576 19.0433 10.4001C19.11 10.1577 19.1039 10.1032 19.0191 9.97593C18.9646 9.89111 18.9222 9.80628 18.9222 9.78811C18.9222 9.76993 19.3342 9.75781 19.831 9.75781C20.5157 9.75781 20.7398 9.77599 20.7398 9.83052C20.7398 9.87293 20.3036 11.424 19.7765 13.272L18.8192 16.6347L18.9706 16.7983L19.1282 16.968H17.9345H16.7409V16.762C16.7409 16.6469 16.5167 15.8289 16.238 14.9443L15.7351 13.3326L15.5473 13.5023L15.3595 13.6658L15.8381 15.1806C16.0987 16.0107 16.3289 16.768 16.3471 16.8589L16.3895 17.0286H15.4201H14.4567L14.281 16.3136L14.1053 15.6047H13.7478H13.3843L12.9177 16.1318C12.4512 16.659 11.8574 17.38 11.615 17.7193L11.4878 17.9011L11.1909 17.6829C11.0273 17.5618 10.791 17.3558 10.6698 17.2285L10.4457 16.9983L10.5305 16.7559C10.6638 16.3803 10.6456 16.3379 10.4214 16.5075C10.3124 16.5923 10.0579 16.7377 9.864 16.8286L9.50046 16.9983L7.76154 17.0165C6.79816 17.0286 6.01655 17.0225 6.01655 16.9983C6.01655 16.9801 6.05897 16.9013 6.1135 16.8165C6.2165 16.659 6.3498 16.1076 7.16776 12.4965C7.47676 11.1332 7.70095 10.0002 7.68277 9.93352C7.64036 9.81234 7.66459 9.81234 9.23992 9.83052C10.8274 9.8487 10.8334 9.8487 11.1849 10.0123C11.3787 10.1032 11.6635 10.3092 11.8271 10.4788L12.124 10.7818L12.1967 10.4304C12.2391 10.2365 12.2512 10.0183 12.227 9.94564C12.1906 9.8184 12.1967 9.8184 13.2449 9.8184C14.2628 9.8184 14.3052 9.82446 14.2749 9.93352C14.2507 10.0305 15.0626 12.8176 15.1353 12.8964C15.1535 12.9145 15.2928 12.8479 15.4564 12.7388C15.517 12.6964 15.4443 12.4116 15.1353 11.418C14.9172 10.7212 14.6991 10.0789 14.6506 9.98805C14.6021 9.90323 14.5597 9.81234 14.5597 9.79417C14.5597 9.77599 15.0384 9.75781 15.62 9.75781H16.6743L16.7349 9.98199ZM6.40433 12.3268C6.7921 12.4904 6.91934 12.8721 6.67698 13.1751C6.61033 13.2599 6.58004 13.3326 6.61033 13.3326C6.64063 13.3326 6.65275 13.3993 6.63457 13.4841C6.62245 13.5689 6.59821 13.6356 6.58004 13.6356C6.56792 13.6356 6.27709 13.5689 5.93779 13.478C4.79264 13.1932 4.87747 13.2296 4.91382 13.0539C4.93806 12.9145 4.96229 12.9024 5.15012 12.9388C5.26524 12.9569 5.39248 12.9872 5.42883 13.0054C5.48336 13.0236 5.50154 12.963 5.48942 12.8055C5.45307 12.345 5.89537 12.1148 6.40433 12.3268ZM6.00444 13.6598C6.0105 13.6719 5.97414 13.8658 5.92567 14.09C5.82267 14.5202 5.84084 14.611 5.99838 14.508C6.18015 14.3929 6.23468 14.2536 6.14985 14.1203C6.06503 13.9749 6.05291 13.781 6.13773 13.7264C6.26497 13.6477 6.44068 13.9324 6.44068 14.2172C6.44068 14.5626 6.19832 14.8473 5.89537 14.8473C5.09559 14.8473 4.81688 13.9324 5.53184 13.6416C5.65907 13.5871 5.94385 13.6053 6.00444 13.6598ZM5.6106 15.0958C5.88326 15.2654 6.11956 15.4169 6.13167 15.429C6.14379 15.4351 6.13773 15.5199 6.1135 15.6047C6.07714 15.7501 6.05291 15.7562 5.66513 15.7562L5.25918 15.7622L5.6106 15.944C5.88932 16.0834 5.95596 16.15 5.95596 16.2712C5.95596 16.35 5.93779 16.4287 5.91355 16.4409C5.88326 16.459 5.56819 16.4893 5.20465 16.5136L4.55028 16.556L4.5927 16.4166C4.65329 16.2227 4.62905 16.2348 5.04712 16.1985L5.41672 16.1621L5.12589 15.9925C4.96835 15.8955 4.81688 15.8107 4.79264 15.8047C4.76841 15.7925 4.76235 15.7259 4.78052 15.6532C4.81688 15.532 4.86535 15.5199 5.25312 15.5017L5.68331 15.4835L5.3016 15.2836C5.02288 15.1382 4.92594 15.0594 4.95018 14.9928C4.96835 14.9382 4.98653 14.8716 4.98653 14.8413C4.98653 14.7383 5.11377 14.7868 5.6106 15.0958Z"
        fill="#3781F7"
      />
      <path
        d="M9.39129 10.9514C9.361 11.006 8.13708 15.835 8.13708 15.9077C8.13708 15.9743 8.93687 15.9319 9.1247 15.8592C9.45794 15.7198 9.93054 15.1321 10.2577 14.4596C10.6637 13.6234 10.7667 13.2054 10.7667 12.3935C10.7727 11.8239 10.7546 11.6906 10.6394 11.4846C10.4153 11.0666 10.2456 10.9454 9.80936 10.9211C9.5973 10.909 9.40947 10.9211 9.39129 10.9514Z"
        fill="#3781F7"
      />
      <path
        d="M18.0618 11.4786C17.6438 11.7815 17.2802 12.042 17.2681 12.0602C17.2499 12.0784 17.3651 12.6358 17.5226 13.3023L17.8134 14.5141L17.971 13.9991C18.4557 12.3874 18.8677 10.9575 18.8495 10.9393C18.8374 10.9332 18.486 11.1756 18.0618 11.4786Z"
        fill="#3781F7"
      />
      <path
        d="M12.8693 13.3811C12.6936 13.9082 12.53 14.3687 12.5179 14.405C12.4936 14.4596 12.5724 14.4838 12.7966 14.4838C13.0632 14.4838 13.1541 14.4535 13.4086 14.2536C13.5721 14.1324 13.7054 13.9991 13.7054 13.9688C13.7115 13.9082 13.245 12.4843 13.2147 12.448C13.2025 12.4419 13.0511 12.86 12.8693 13.3811Z"
        fill="#3781F7"
      />
      <path
        d="M5.84684 12.6419C5.6893 12.7509 5.67718 12.9145 5.8226 13.0478C5.99831 13.2114 6.22249 13.2296 6.38002 13.1024C6.55573 12.9569 6.51332 12.7206 6.28914 12.6176C6.08314 12.5207 6.01043 12.5268 5.84684 12.6419Z"
        fill="#3781F7"
      />
      <path
        d="M5.54398 13.9688C5.3925 14.0779 5.36827 14.3142 5.4955 14.4232C5.56821 14.4778 5.59851 14.4475 5.65304 14.2415C5.73786 13.9203 5.71363 13.8537 5.54398 13.9688Z"
        fill="#3781F7"
      />
    </>
  ),
  outline: false,
};

export const car = {
  path: () => (
    <>
      <path
        stroke-width="0.1"
        d="M20.985 10.3491C20.9743 10.2995 20.9586 10.2511 20.9381 10.2047L19.1672 6.07219C18.7589 5.11734 17.7656 4.5 16.6355 4.5H7.36453C6.23531 4.5 5.24109 5.11734 4.83328 6.07219L3.06047 10.2047C3.02018 10.2979 2.99959 10.3984 3 10.5V18.75C3 18.9489 3.07902 19.1397 3.21967 19.2803C3.36032 19.421 3.55109 19.5 3.75 19.5H5.25C5.44891 19.5 5.63968 19.421 5.78033 19.2803C5.92098 19.1397 6 18.9489 6 18.75V18H18V18.75C18 18.9489 18.079 19.1397 18.2197 19.2803C18.3603 19.421 18.5511 19.5 18.75 19.5H20.25C20.4489 19.5 20.6397 19.421 20.7803 19.2803C20.921 19.1397 21 18.9489 21 18.75V10.5C21.0001 10.4493 20.995 10.3987 20.985 10.3491ZM6.75 15C6.45333 15 6.16332 14.912 5.91664 14.7472C5.66997 14.5824 5.47771 14.3481 5.36418 14.074C5.25065 13.7999 5.22094 13.4983 5.27882 13.2074C5.3367 12.9164 5.47956 12.6491 5.68934 12.4393C5.89912 12.2296 6.16639 12.0867 6.45736 12.0288C6.74833 11.9709 7.04993 12.0006 7.32402 12.1142C7.59811 12.2277 7.83238 12.42 7.9972 12.6666C8.16202 12.9133 8.25 13.2033 8.25 13.5C8.25 13.8978 8.09196 14.2794 7.81066 14.5607C7.52935 14.842 7.14782 15 6.75 15ZM17.25 15C16.9533 15 16.6633 14.912 16.4166 14.7472C16.17 14.5824 15.9777 14.3481 15.8642 14.074C15.7506 13.7999 15.7209 13.4983 15.7788 13.2074C15.8367 12.9164 15.9796 12.6491 16.1893 12.4393C16.3991 12.2296 16.6664 12.0867 16.9574 12.0288C17.2483 11.9709 17.5499 12.0006 17.824 12.1142C18.0981 12.2277 18.3324 12.42 18.4972 12.6666C18.662 12.9133 18.75 13.2033 18.75 13.5C18.75 13.8978 18.592 14.2794 18.3107 14.5607C18.0294 14.842 17.6478 15 17.25 15ZM4.88719 9.75L6.21047 6.66328C6.38015 6.26672 6.84375 6 7.36453 6H16.6355C17.1558 6 17.6198 6.26672 17.7895 6.66328L19.1128 9.75H4.88719Z"
      />
    </>
  ),
  outline: false,
};

export const webhook = {
  path: () => (
    <path
      d="M7 21C5.61667 21 4.4375 20.5125 3.4625 19.5375C2.4875 18.5625 2 17.3833 2 16C2 14.7833 2.37917 13.7208 3.1375 12.8125C3.89583 11.9042 4.85 11.3333 6 11.1V13.175C5.41667 13.375 4.9375 13.7333 4.5625 14.25C4.1875 14.7667 4 15.35 4 16C4 16.8333 4.29167 17.5417 4.875 18.125C5.45833 18.7083 6.16667 19 7 19C7.83333 19 8.54167 18.7083 9.125 18.125C9.70833 17.5417 10 16.8333 10 16V15H15.875C16.0083 14.85 16.1708 14.7292 16.3625 14.6375C16.5542 14.5458 16.7667 14.5 17 14.5C17.4167 14.5 17.7708 14.6458 18.0625 14.9375C18.3542 15.2292 18.5 15.5833 18.5 16C18.5 16.4167 18.3542 16.7708 18.0625 17.0625C17.7708 17.3542 17.4167 17.5 17 17.5C16.7667 17.5 16.5542 17.4542 16.3625 17.3625C16.1708 17.2708 16.0083 17.15 15.875 17H11.9C11.6667 18.15 11.0958 19.1042 10.1875 19.8625C9.27917 20.6208 8.21667 21 7 21ZM17 21C16.0667 21 15.2208 20.7708 14.4625 20.3125C13.7042 19.8542 13.1083 19.25 12.675 18.5H15.35C15.5833 18.6667 15.8417 18.7917 16.125 18.875C16.4083 18.9583 16.7 19 17 19C17.8333 19 18.5417 18.7083 19.125 18.125C19.7083 17.5417 20 16.8333 20 16C20 15.1667 19.7083 14.4583 19.125 13.875C18.5417 13.2917 17.8333 13 17 13C16.6667 13 16.3583 13.0458 16.075 13.1375C15.7917 13.2292 15.525 13.3667 15.275 13.55L12.225 8.475C11.875 8.40833 11.5833 8.24167 11.35 7.975C11.1167 7.70833 11 7.38333 11 7C11 6.58333 11.1458 6.22917 11.4375 5.9375C11.7292 5.64583 12.0833 5.5 12.5 5.5C12.9167 5.5 13.2708 5.64583 13.5625 5.9375C13.8542 6.22917 14 6.58333 14 7V7.2125C14 7.27083 13.9833 7.34167 13.95 7.425L16.125 11.075C16.2583 11.0417 16.4 11.0208 16.55 11.0125C16.7 11.0042 16.85 11 17 11C18.3833 11 19.5625 11.4875 20.5375 12.4625C21.5125 13.4375 22 14.6167 22 16C22 17.3833 21.5125 18.5625 20.5375 19.5375C19.5625 20.5125 18.3833 21 17 21ZM7 17.5C6.58333 17.5 6.22917 17.3542 5.9375 17.0625C5.64583 16.7708 5.5 16.4167 5.5 16C5.5 15.6333 5.61667 15.3167 5.85 15.05C6.08333 14.7833 6.36667 14.6083 6.7 14.525L9.05 10.625C8.56667 10.175 8.1875 9.6375 7.9125 9.0125C7.6375 8.3875 7.5 7.71667 7.5 7C7.5 5.61667 7.9875 4.4375 8.9625 3.4625C9.9375 2.4875 11.1167 2 12.5 2C13.8833 2 15.0625 2.4875 16.0375 3.4625C17.0125 4.4375 17.5 5.61667 17.5 7H15.5C15.5 6.16667 15.2083 5.45833 14.625 4.875C14.0417 4.29167 13.3333 4 12.5 4C11.6667 4 10.9583 4.29167 10.375 4.875C9.79167 5.45833 9.5 6.16667 9.5 7C9.5 7.71667 9.71667 8.34583 10.15 8.8875C10.5833 9.42917 11.1333 9.775 11.8 9.925L8.425 15.55C8.45833 15.6333 8.47917 15.7083 8.4875 15.775C8.49583 15.8417 8.5 15.9167 8.5 16C8.5 16.4167 8.35417 16.7708 8.0625 17.0625C7.77083 17.3542 7.41667 17.5 7 17.5Z"
      fill="currentColor"
    />
  ),
  outline: false,
};

export const vertical = {
  path: () => (
    <path
      d="M16 6V18M16 18L12 14M16 18L20 14M4 10H7C7.55228 10 8 9.55228 8 9V7C8 6.44772 7.55228 6 7 6H4C3.44772 6 3 6.44772 3 7V9C3 9.55228 3.44772 10 4 10ZM4 18H7C7.55228 18 8 17.5523 8 17V15C8 14.4477 7.55228 14 7 14H4C3.44772 14 3 14.4477 3 15V17C3 17.5523 3.44772 18 4 18Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      fill="none"
    />
  ),
  outline: false,
};

export const horizontal = {
  path: () => (
    <path
      d="M6 8H18M18 8L14 12M18 8L14 4M10 20V17C10 16.4477 9.55228 16 9 16H7C6.44772 16 6 16.4477 6 17V20C6 20.5523 6.44772 21 7 21H9C9.55228 21 10 20.5523 10 20ZM18 20V17C18 16.4477 17.5523 16 17 16H15C14.4477 16 14 16.4477 14 17V20C14 20.5523 14.4477 21 15 21H17C17.5523 21 18 20.5523 18 20Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      fill="none"
    />
  ),
  outline: false,
};

export const addFolder = {
  path: () => (
    <>
      <path
        d="M11 6H16C17.1046 6 18 6.89543 18 8V9.88379C17.7359 9.64703 17.3883 9.50149 17.0059 9.5H16.9844C16.9709 9.49995 16.951 9.4991 16.9258 9.49902C16.8749 9.49887 16.8015 9.49923 16.7109 9.49902C16.5291 9.4986 16.2776 9.49805 16 9.49805C15.7227 9.49805 15.4717 9.49862 15.29 9.49902C15.1992 9.49922 15.1251 9.49887 15.0742 9.49902C15.0488 9.4991 15.0291 9.49996 15.0156 9.5H14.9951C14.1688 9.50296 13.5 10.1737 13.5 11V13.498H11.0029C10.404 13.4981 10.0301 13.8359 9.88574 13.9971C9.73664 14.1635 9.66166 14.3238 9.63281 14.3887C9.57038 14.529 9.54463 14.6469 9.53809 14.6768C9.52001 14.7591 9.51228 14.8254 9.51074 14.8398C9.50605 14.8838 9.50432 14.9196 9.50391 14.9277C9.50264 14.953 9.50217 14.9756 9.50195 14.9854C9.50142 15.0094 9.5012 15.0378 9.50098 15.0645C9.50051 15.1202 9.50017 15.1974 9.5 15.2881V16.708C9.50019 16.7988 9.50052 16.8761 9.50098 16.9316C9.5012 16.9583 9.50145 16.9862 9.50195 17.0098C9.50216 17.0193 9.50277 17.0406 9.50391 17.0645C9.50427 17.0721 9.50654 17.1058 9.51074 17.1475C9.51203 17.1602 9.51791 17.2232 9.53418 17.3018C9.53986 17.3292 9.56316 17.4434 9.62012 17.5791C9.64593 17.6406 9.71619 17.7986 9.85742 17.9658C9.86663 17.9767 9.87892 17.9871 9.89062 18H4C2.89543 18 2 17.1046 2 16V6C2 4.89543 2.89543 4 4 4H9L11 6Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16 11C16.5523 11 17 11.4477 17 12V15H20C20.5523 15 21 15.4477 21 16C21 16.5523 20.5523 17 20 17H17V20C17 20.5523 16.5523 21 16 21C15.4477 21 15 20.5523 15 20V17H12C11.4477 17 11 16.5523 11 16C11 15.4477 11.4477 15 12 15H15V12C15 11.4477 15.4477 11 16 11Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const editFolder = {
  path: () => (
    <>
      <path
        d="M11 6H16C17.1046 6 18 6.89543 18 8V9.95898C17.8643 10.0455 17.7333 10.1428 17.6104 10.2539L17.501 10.3574L9.93945 17.9189C9.9136 17.9448 9.88996 17.9725 9.86621 18H4C2.89543 18 2 17.1046 2 16V6C2 4.89543 2.89543 4 4 4H9L11 6Z"
        fill="currentColor"
      />
      <path
        d="M18.5613 11.4184C19.1192 10.8605 20.0237 10.8605 20.5816 11.4184C21.1395 11.9763 21.1395 12.8808 20.5816 13.4387L20.0152 14.0051L17.9949 11.9848L18.5613 11.4184Z"
        fill="currentColor"
      />
      <path d="M16.9848 12.9949L11 18.9797V21H13.0203L19.0051 15.0152L16.9848 12.9949Z" fill="currentColor" />
    </>
  ),
  outline: false,
};

export const deleteFolder = {
  path: () => (
    <>
      <path
        d="M11 6H16C17.1046 6 18 6.89543 18 8V9.67578C17.7342 9.5618 17.4456 9.50005 17.1504 9.5H15.8643C15.124 9.50003 14.4216 9.88143 14.0293 10.5273L13.9551 10.6592L13.9082 10.75H12.002C11.2264 10.75 10.5879 11.3386 10.5098 12.0938L10.502 12.2471V12.3936C10.5018 12.4838 10.5012 12.6084 10.501 12.7432C10.5005 13.0122 10.5 13.3259 10.5 13.5C10.5 14.0128 10.7578 14.4648 11.1504 14.7354V18H4C2.89543 18 2 17.1046 2 16V6C2 4.89543 2.89543 4 4 4H9L11 6Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.8571 11C15.6136 11 15.391 11.1338 15.2822 11.3455L14.817 12.25H12.6429C12.2878 12.25 12 12.5298 12 12.875C12 13.2202 12.2878 13.5 12.6429 13.5V19.75C12.6429 20.4404 13.2185 21 13.9286 21H19.0714C19.7815 21 20.3571 20.4404 20.3571 19.75V13.5C20.7122 13.5 21 13.2202 21 12.875C21 12.5298 20.7122 12.25 20.3571 12.25H18.183L17.7178 11.3455C17.609 11.1338 17.3864 11 17.1429 11H15.8571ZM14.5714 14.75C14.5714 14.4048 14.8592 14.125 15.2143 14.125C15.5693 14.125 15.8571 14.4048 15.8571 14.75V18.5C15.8571 18.8452 15.5693 19.125 15.2143 19.125C14.8592 19.125 14.5714 18.8452 14.5714 18.5V14.75ZM17.7857 14.125C17.4307 14.125 17.1429 14.4048 17.1429 14.75V18.5C17.1429 18.8452 17.4307 19.125 17.7857 19.125C18.1408 19.125 18.4286 18.8452 18.4286 18.5V14.75C18.4286 14.4048 18.1408 14.125 17.7857 14.125Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const folderAccess = {
  path: () => (
    <>
      <path
        d="M12 6H17C18.1046 6 19 6.89543 19 8V8.74023C18.5274 8.58468 18.0229 8.5 17.5 8.5C14.9365 8.5 12.7861 10.5311 12.7861 13.125V13.3096C12.0214 13.7918 11.5 14.6338 11.5 15.625V17.9922C11.1327 17.9905 10.873 17.9921 10.8662 18H5C3.89543 18 3 17.1046 3 16V6C3 4.89543 3.89543 4 5 4H10L12 6Z"
        fill="currentColor"
      />
      <path
        d="M17.5 10C15.7248 10 14.2857 11.3991 14.2857 13.125V14.375C13.5756 14.375 13 14.9346 13 15.625V18.75C13 19.4404 13.5756 20 14.2857 20H20.7143C21.4244 20 22 19.4404 22 18.75V15.625C22 14.9346 21.4244 14.375 20.7143 14.375H15.5714V13.125C15.5714 12.0895 16.4349 11.25 17.5 11.25C18.3978 11.25 19.1537 11.847 19.3679 12.6558C19.4563 12.9901 19.8068 13.1913 20.1507 13.1053C20.4945 13.0192 20.7015 12.6785 20.613 12.3442C20.2562 10.9965 18.9986 10 17.5 10Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const addForm = {
  path: () => (
    <>
      <path
        d="M10.5859 2C11.1163 2.00004 11.625 2.2109 12 2.58594L15.4141 6C15.7891 6.37504 16 6.88368 16 7.41406V9.88574C15.7359 9.64899 15.3883 9.50345 15.0059 9.50195H14.9844C14.9709 9.50191 14.951 9.50105 14.9258 9.50098C14.8749 9.50082 14.8015 9.50119 14.7109 9.50098C14.5291 9.50056 14.2776 9.5 14 9.5C13.7227 9.5 13.4717 9.50057 13.29 9.50098C13.1992 9.50118 13.1251 9.50083 13.0742 9.50098C13.0488 9.50105 13.0291 9.50191 13.0156 9.50195H12.9951C12.1688 9.50491 11.5 10.1757 11.5 11.002V13.5H9.00293C8.40403 13.5 8.03013 13.8379 7.88574 13.999C7.73664 14.1654 7.66166 14.3258 7.63281 14.3906C7.57038 14.5309 7.54463 14.6489 7.53809 14.6787C7.52001 14.7611 7.51228 14.8274 7.51074 14.8418C7.50605 14.8858 7.50432 14.9215 7.50391 14.9297C7.50264 14.9549 7.50217 14.9776 7.50195 14.9873C7.50142 15.0114 7.5012 15.0398 7.50098 15.0664C7.50051 15.1222 7.50017 15.1993 7.5 15.29V16.71C7.50019 16.8007 7.50052 16.8781 7.50098 16.9336C7.5012 16.9602 7.50145 16.9882 7.50195 17.0117C7.50216 17.0213 7.50277 17.0425 7.50391 17.0664C7.50427 17.0741 7.50654 17.1078 7.51074 17.1494C7.51203 17.1622 7.51791 17.2251 7.53418 17.3037C7.53986 17.3311 7.56316 17.4454 7.62012 17.5811C7.64593 17.6425 7.71619 17.8006 7.85742 17.9678C7.86615 17.9781 7.87772 17.9879 7.88867 18H6C4.89543 18 4 17.1046 4 16V4C4 2.89543 4.89543 2 6 2H10.5859Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14 11.002C14.5523 11.002 15 11.4497 15 12.002V15.002H18C18.5523 15.002 19 15.4497 19 16.002C19 16.5542 18.5523 17.002 18 17.002H15V20.002C15 20.5542 14.5523 21.002 14 21.002C13.4477 21.002 13 20.5542 13 20.002V17.002H10C9.44772 17.002 9 16.5542 9 16.002C9 15.4497 9.44772 15.002 10 15.002H13V12.002C13 11.4497 13.4477 11.002 14 11.002Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const editForm = {
  path: () => (
    <>
      <path
        d="M10.5859 3C11.1163 3.00004 11.625 3.2109 12 3.58594L15.4141 7C15.7891 7.37504 16 7.88368 16 8.41406V11.8584L8.93945 18.9189C8.9136 18.9448 8.88996 18.9725 8.86621 19H6C4.89543 19 4 18.1046 4 17V5C4 3.89543 4.89543 3 6 3H10.5859Z"
        fill="currentColor"
      />
      <path
        d="M17.5613 12.4184C18.1192 11.8605 19.0237 11.8605 19.5816 12.4184C20.1395 12.9763 20.1395 13.8808 19.5816 14.4387L19.0152 15.0051L16.9949 12.9848L17.5613 12.4184Z"
        fill="currentColor"
      />
      <path d="M15.9848 13.9949L10 19.9797V22H12.0203L18.0051 16.0152L15.9848 13.9949Z" fill="currentColor" />
    </>
  ),
  outline: false,
};

export const moveForm = {
  path: () => (
    <>
      <path
        d="M11.5859 3C12.1163 3.00004 12.625 3.2109 13 3.58594L16.4141 7C16.7891 7.37504 17 7.88368 17 8.41406V10.3574C16.8837 10.3217 16.7548 10.2959 16.6133 10.2881C16.0043 10.2544 15.5729 10.5683 15.4355 10.6709C15.25 10.8094 15.0681 10.9853 14.9033 11.1533L14.9043 11.1553C14.5568 11.5045 14.3567 11.9424 14.3027 12.3955H12.5527C12.1549 12.3955 11.7725 12.5537 11.4912 12.835C11.2101 13.1162 11.0528 13.4979 11.0527 13.8955V15.1455C11.0527 15.4318 11.1354 15.7092 11.2861 15.9473C11.2686 15.9603 11.2506 15.9727 11.2334 15.9863L11.0713 16.1289L9.14258 18.0039C8.86167 18.2771 8.66391 18.6224 8.56738 19H7C5.89543 19 5 18.1046 5 17V5C5 3.89543 5.89543 3 7 3H11.5859Z"
        fill="currentColor"
      />
      <path
        d="M12.8135 17.0664C12.891 17.0969 12.9635 17.143 13.0264 17.2041C12.9949 17.1735 12.9605 17.1469 12.9248 17.124L12.8135 17.0664Z"
        fill="currentColor"
      />
      <path
        d="M13.2143 13.875C12.8592 13.875 12.5714 14.1548 12.5714 14.5C12.5714 14.8452 12.8592 15.125 13.2143 15.125L16.8051 15.125L15.974 15.9331C15.723 16.1771 15.723 16.5729 15.974 16.8169C16.2251 17.061 16.6321 17.061 16.8831 16.8169L18.8117 14.9419C18.9323 14.8247 19 14.6658 19 14.5C19 14.3342 18.9323 14.1753 18.8117 14.0581L16.8831 12.1831C16.6321 11.939 16.2251 11.939 15.974 12.1831C15.723 12.4271 15.723 12.8229 15.974 13.0669L16.8051 13.875L13.2143 13.875Z"
        fill="currentColor"
      />
      <path
        d="M15.7857 20.125C16.1408 20.125 16.4286 19.8452 16.4286 19.5C16.4286 19.1548 16.1408 18.875 15.7857 18.875H12.1949L13.026 18.0669C13.277 17.8229 13.277 17.4271 13.026 17.1831C12.7749 16.939 12.3679 16.939 12.1169 17.1831L10.1883 19.0581C10.0677 19.1753 10 19.3342 10 19.5C10 19.6658 10.0677 19.8247 10.1883 19.9419L12.1169 21.8169C12.3679 22.061 12.7749 22.061 13.026 21.8169C13.277 21.5729 13.277 21.1771 13.026 20.9331L12.1949 20.125L15.7857 20.125Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const deleteForm = {
  path: () => (
    <>
      <path
        d="M10.5859 3C11.1163 3.00004 11.625 3.2109 12 3.58594L15.4141 7C15.7891 7.37504 16 7.88368 16 8.41406V10.5H14.8643C14.124 10.5 13.4216 10.8814 13.0293 11.5273L12.9551 11.6592L12.9082 11.75H11.002C10.2264 11.75 9.58793 12.3386 9.50977 13.0938L9.50195 13.2471V13.3936C9.50177 13.4838 9.50122 13.6084 9.50098 13.7432C9.50049 14.0122 9.5 14.3259 9.5 14.5C9.5 15.0128 9.75781 15.4648 10.1504 15.7354V19H6C4.89543 19 4 18.1046 4 17V5C4 3.89543 4.89543 3 6 3H10.5859Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.8571 12C14.6136 12 14.391 12.1338 14.2822 12.3455L13.817 13.25H11.6429C11.2878 13.25 11 13.5298 11 13.875C11 14.2202 11.2878 14.5 11.6429 14.5L11.6429 20.75C11.6429 21.4404 12.2185 22 12.9286 22H18.0714C18.7815 22 19.3571 21.4404 19.3571 20.75V14.5C19.7122 14.5 20 14.2202 20 13.875C20 13.5298 19.7122 13.25 19.3571 13.25H17.183L16.7178 12.3455C16.609 12.1338 16.3864 12 16.1429 12H14.8571ZM13.5714 15.75C13.5714 15.4048 13.8592 15.125 14.2143 15.125C14.5693 15.125 14.8571 15.4048 14.8571 15.75V19.5C14.8571 19.8452 14.5693 20.125 14.2143 20.125C13.8592 20.125 13.5714 19.8452 13.5714 19.5V15.75ZM16.7857 15.125C16.4307 15.125 16.1429 15.4048 16.1429 15.75V19.5C16.1429 19.8452 16.4307 20.125 16.7857 20.125C17.1408 20.125 17.4286 19.8452 17.4286 19.5V15.75C17.4286 15.4048 17.1408 15.125 16.7857 15.125Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const previewForm = {
  path: () => (
    <>
      <path
        d="M10.5859 2C11.1163 2.00004 11.625 2.2109 12 2.58594L15.4141 6C15.7891 6.37504 16 6.88368 16 7.41406V12.5723C15.6731 12.5252 15.3392 12.5 15 12.5C12.0257 12.5 9.45148 14.369 8.5752 17.0312L8.4209 17.5L8.5752 17.9688C8.57864 17.9792 8.58244 17.9896 8.58594 18H6C4.89543 18 4 17.1046 4 16V4C4 2.89543 4.89543 2 6 2H10.5859Z"
        fill="currentColor"
      />
      <path
        d="M15 18.5C15.5788 18.5 16.048 18.0523 16.048 17.5C16.048 16.9477 15.5788 16.5 15 16.5C14.4212 16.5 13.952 16.9477 13.952 17.5C13.952 18.0523 14.4212 18.5 15 18.5Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10 17.5C10.6677 15.4715 12.6538 14 15 14C17.3462 14 19.3323 15.4714 20 17.5C19.3323 19.5285 17.3462 21 15 21C12.6538 21 10.6677 19.5286 10 17.5ZM17.096 17.5C17.096 18.6046 16.1576 19.5 15 19.5C13.8425 19.5 12.9041 18.6046 12.9041 17.5C12.9041 16.3954 13.8425 15.5 15 15.5C16.1576 15.5 17.096 16.3954 17.096 17.5Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};
export const removeForm = {
  path: () => (
    <>
      <path
        d="M11.5859 2C12.1163 2.00004 12.625 2.2109 13 2.58594L16.4141 6C16.7891 6.37504 17 6.88368 17 7.41406V11.8184L15.5 13.3184L13.3408 11.1592C12.4621 10.2805 11.0379 10.2805 10.1592 11.1592C9.2805 12.0379 9.2805 13.4621 10.1592 14.3408L12.3184 16.5L10.8184 18H7C5.89543 18 5 17.1046 5 16V4C5 2.89543 5.89543 2 7 2H11.5859Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.2197 12.2197C11.5126 11.9268 11.9874 11.9268 12.2803 12.2197L15.5 15.4393L18.7197 12.2197C19.0126 11.9268 19.4874 11.9268 19.7803 12.2197C20.0732 12.5126 20.0732 12.9874 19.7803 13.2803L16.5607 16.5L19.7803 19.7197C20.0732 20.0126 20.0732 20.4874 19.7803 20.7803C19.4874 21.0732 19.0126 21.0732 18.7197 20.7803L15.5 17.5607L12.2803 20.7803C11.9874 21.0732 11.5126 21.0732 11.2197 20.7803C10.9268 20.4874 10.9268 20.0126 11.2197 19.7197L14.4393 16.5L11.2197 13.2803C10.9268 12.9874 10.9268 12.5126 11.2197 12.2197Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};
export const restoreForm = {
  path: () => (
    <>
      <path
        d="M11.5859 2C12.1163 2.00004 12.625 2.2109 13 2.58594L16.4141 6C16.7891 6.37504 17 6.88368 17 7.41406V11.1523C16.6755 11.0934 16.3413 11.0625 16 11.0625C15.3862 11.0625 14.7955 11.1636 14.2432 11.3477C13.8626 10.8307 13.2493 10.5 12.5713 10.5C11.4497 10.5001 10.5 11.4013 10.5 12.5625V15.375C10.5 15.8613 10.6684 16.3004 10.9443 16.6484C10.7309 17.0423 10.6468 17.5039 10.7266 17.9688H9.5752C9.57864 17.9792 9.58244 17.9896 9.58594 18H7C5.89543 18 5 17.1046 5 16V4C5 2.89543 5.89543 2 7 2H11.5859Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.5714 12C12.887 12 13.1429 12.2518 13.1429 12.5625V13.7445C13.8686 13.0152 14.8803 12.5625 16 12.5625C17.7425 12.5625 19.2234 13.659 19.7722 15.1875C19.8774 15.4805 19.7215 15.8018 19.4239 15.9053C19.1264 16.0089 18.7999 15.8554 18.6947 15.5625C18.3022 14.4693 17.2431 13.6875 16 13.6875C15.0658 13.6875 14.2354 14.1291 13.7139 14.8125H15.4286C15.7442 14.8125 16 15.0643 16 15.375C16 15.6857 15.7442 15.9375 15.4286 15.9375H12.5714C12.2558 15.9375 12 15.6857 12 15.375V12.5625C12 12.2518 12.2558 12 12.5714 12ZM12.5761 17.0947C12.8736 16.9911 13.2001 17.1446 13.3053 17.4375C13.6978 18.5307 14.7569 19.3125 16 19.3125C16.9342 19.3125 17.7646 18.8709 18.2861 18.1875H16.5714C16.2558 18.1875 16 17.9357 16 17.625C16 17.3143 16.2558 17.0625 16.5714 17.0625H19.4286C19.5801 17.0625 19.7255 17.1218 19.8326 17.2273C19.9398 17.3327 20 17.4758 20 17.625V20.4375C20 20.7482 19.7442 21 19.4286 21C19.113 21 18.8571 20.7482 18.8571 20.4375V19.2555C18.1314 19.9848 17.1197 20.4375 16 20.4375C14.2575 20.4375 12.7766 19.341 12.2278 17.8125C12.1226 17.5195 12.2785 17.1982 12.5761 17.0947Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};
export const formAccess = {
  path: () => (
    <>
      <path
        d="M10.5859 2C11.1163 2.00004 11.625 2.2109 12 2.58594L15.4141 6C15.7891 6.37504 16 6.88368 16 7.41406V9.5L15.9189 9.71387C15.4699 9.57494 14.993 9.5 14.5 9.5C11.9365 9.5 9.78613 11.5311 9.78613 14.125V14.3096C9.02141 14.7918 8.5 15.6338 8.5 16.625V18H6C4.89543 18 4 17.1046 4 16V4C4 2.89543 4.89543 2 6 2H10.5859Z"
        fill="currentColor"
      />
      <path
        d="M14.5 11C12.7248 11 11.2857 12.3991 11.2857 14.125V15.375C10.5756 15.375 10 15.9346 10 16.625V19.75C10 20.4404 10.5756 21 11.2857 21H17.7143C18.4244 21 19 20.4404 19 19.75V16.625C19 15.9346 18.4244 15.375 17.7143 15.375H12.5714V14.125C12.5714 13.0895 13.4349 12.25 14.5 12.25C15.3978 12.25 16.1537 12.847 16.3679 13.6558C16.4563 13.9901 16.8068 14.1913 17.1507 14.1053C17.4945 14.0192 17.7015 13.6785 17.613 13.3442C17.2562 11.9965 15.9986 11 14.5 11Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const createTask = {
  path: () => (
    <>
      <path
        d="M14 3C15.1046 3 16 3.89543 16 5V9.88574C15.7359 9.64899 15.3883 9.50345 15.0059 9.50195H14.9844C14.9709 9.50191 14.951 9.50105 14.9258 9.50098C14.8749 9.50082 14.8015 9.50119 14.7109 9.50098C14.5291 9.50056 14.2776 9.5 14 9.5C13.7227 9.5 13.4717 9.50057 13.29 9.50098C13.1992 9.50118 13.1251 9.50083 13.0742 9.50098C13.0488 9.50105 13.0291 9.50191 13.0156 9.50195H12.9951C12.1688 9.50491 11.5 10.1757 11.5 11.002V13.5H9.00293C8.40403 13.5 8.03013 13.8379 7.88574 13.999C7.73664 14.1654 7.66166 14.3258 7.63281 14.3906C7.57038 14.5309 7.54463 14.6489 7.53809 14.6787C7.52001 14.7611 7.51228 14.8274 7.51074 14.8418C7.50605 14.8858 7.50432 14.9215 7.50391 14.9297C7.50264 14.9549 7.50217 14.9776 7.50195 14.9873C7.50142 15.0114 7.5012 15.0398 7.50098 15.0664C7.50051 15.1222 7.50017 15.1993 7.5 15.29V16.71C7.50019 16.8007 7.50052 16.8781 7.50098 16.9336C7.5012 16.9602 7.50145 16.9882 7.50195 17.0117C7.50216 17.0213 7.50277 17.0425 7.50391 17.0664C7.50427 17.0741 7.50654 17.1078 7.51074 17.1494C7.51203 17.1622 7.51791 17.2251 7.53418 17.3037C7.53986 17.3311 7.56316 17.4454 7.62012 17.5811C7.64593 17.6425 7.71619 17.8006 7.85742 17.9678C7.86615 17.9781 7.87772 17.9879 7.88867 18H6C4.89543 18 4 17.1046 4 16V5C4 3.89543 4.89543 3 6 3C6 4.65685 7.34315 6 9 6H11C12.6569 6 14 4.65685 14 3Z"
        fill="currentColor"
      />
      <path
        d="M11 2C11.5523 2 12 2.44772 12 3C12 3.55228 11.5523 4 11 4H9C8.44772 4 8 3.55228 8 3C8 2.44772 8.44772 2 9 2H11Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14 11.002C14.5523 11.002 15 11.4497 15 12.002V15.002H18C18.5523 15.002 19 15.4497 19 16.002C19 16.5542 18.5523 17.002 18 17.002H15V20.002C15 20.5542 14.5523 21.002 14 21.002C13.4477 21.002 13 20.5542 13 20.002V17.002H10C9.44772 17.002 9 16.5542 9 16.002C9 15.4497 9.44772 15.002 10 15.002H13V12.002C13 11.4497 13.4477 11.002 14 11.002Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const viewTask = {
  path: () => (
    <>
      <path
        d="M14 4C15.1046 4 16 4.89543 16 6V13.792C15.3661 13.6022 14.694 13.5 14 13.5C11.0257 13.5 8.45148 15.369 7.5752 18.0312L7.4209 18.5L7.5752 18.9688C7.57864 18.9792 7.58244 18.9896 7.58594 19H6C4.89543 19 4 18.1046 4 17V6C4 4.89543 4.89543 4 6 4C6 5.65685 7.34315 7 9 7H11C12.6569 7 14 5.65685 14 4Z"
        fill="currentColor"
      />
      <path
        d="M11 3C11.5523 3 12 3.44772 12 4C12 4.55228 11.5523 5 11 5H9C8.44772 5 8 4.55228 8 4C8 3.44772 8.44772 3 9 3H11Z"
        fill="currentColor"
      />
      <path
        d="M14 19.5C14.5788 19.5 15.048 19.0523 15.048 18.5C15.048 17.9477 14.5788 17.5 14 17.5C13.4212 17.5 12.952 17.9477 12.952 18.5C12.952 19.0523 13.4212 19.5 14 19.5Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9 18.5C9.66769 16.4715 11.6538 15 14 15C16.3462 15 18.3323 16.4714 19 18.5C18.3323 20.5285 16.3462 22 14 22C11.6538 22 9.66771 20.5286 9 18.5ZM16.096 18.5C16.096 19.6046 15.1576 20.5 14 20.5C12.8425 20.5 11.9041 19.6046 11.9041 18.5C11.9041 17.3954 12.8425 16.5 14 16.5C15.1576 16.5 16.096 17.3954 16.096 18.5Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const revokeTask = {
  path: () => (
    <>
      <path
        d="M15 4C16.1046 4 17 4.89543 17 6V10.876C16.9403 10.9157 16.8816 10.9578 16.8252 11.0039L16.6543 11.1582L14.4863 13.3252L12.0518 10.9307L12.0508 10.9316C11.8609 10.7437 11.5679 10.5163 11.1582 10.4141C10.7089 10.3019 10.3027 10.3834 9.99707 10.5195C9.72693 10.6399 9.52999 10.8051 9.4248 10.8984C9.31801 10.9932 9.20934 11.1041 9.15527 11.1582C9.10253 11.2109 8.99065 11.32 8.89648 11.4258C8.80377 11.53 8.63744 11.7277 8.5166 11.999C8.37939 12.3072 8.29997 12.7147 8.41406 13.1641C8.51748 13.5712 8.74337 13.8623 8.92871 14.0498L8.92773 14.0508L11.3223 16.4893L9.15527 18.6582C9.0488 18.7647 8.95567 18.8794 8.875 19H7C5.89543 19 5 18.1046 5 17V6C5 4.89543 5.89543 4 7 4C7 5.65685 8.34315 7 10 7H12C13.6569 7 15 5.65685 15 4Z"
        fill="currentColor"
      />
      <path
        d="M12 3C12.5523 3 13 3.44772 13 4C13 4.55228 12.5523 5 12 5H10C9.44772 5 9 4.55228 9 4C9 3.44772 9.44772 3 10 3H12Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.2197 12.2197C10.5126 11.9268 10.9874 11.9268 11.2803 12.2197L14.5 15.4393L17.7197 12.2197C18.0126 11.9268 18.4874 11.9268 18.7803 12.2197C19.0732 12.5126 19.0732 12.9874 18.7803 13.2803L15.5607 16.5L18.7803 19.7197C19.0732 20.0126 19.0732 20.4874 18.7803 20.7803C18.4874 21.0732 18.0126 21.0732 17.7197 20.7803L14.5 17.5607L11.2803 20.7803C10.9874 21.0732 10.5126 21.0732 10.2197 20.7803C9.92678 20.4874 9.92678 20.0126 10.2197 19.7197L13.4393 16.5L10.2197 13.2803C9.92678 12.9874 9.92678 12.5126 10.2197 12.2197Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const completeTask = {
  path: () => (
    <>
      <path
        d="M14 4C15.1046 4 16 4.89543 16 6V13.8457L12.5234 17.252L11.0039 15.8848L11.002 15.8857C10.5972 15.5108 10.0552 15.2783 9.4375 15.3438C8.9205 15.3986 8.53303 15.6516 8.375 15.7568C8.29321 15.8113 8.13304 15.9169 7.97754 16.0527C7.82561 16.1854 7.5898 16.4211 7.42871 16.7725C7.24734 17.1681 7.19892 17.6316 7.33887 18.0967C7.4544 18.4806 7.67348 18.7779 7.88379 19H6C4.89543 19 4 18.1046 4 17V6C4 4.89543 4.89543 4 6 4C6 5.65685 7.34315 7 9 7H11C12.6569 7 14 5.65685 14 4Z"
        fill="currentColor"
      />
      <path
        d="M11 3C11.5523 3 12 3.44772 12 4C12 4.55228 11.5523 5 11 5H9C8.44772 5 8 4.55228 8 4C8 3.44772 8.44772 3 9 3H11Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.7908 14.205C19.0697 14.4784 19.0697 14.9216 18.7908 15.195L13.0765 20.795C12.7976 21.0683 12.3453 21.0683 12.0664 20.795L9.20921 17.995C8.93026 17.7216 8.93026 17.2784 9.20921 17.005C9.48816 16.7317 9.94042 16.7317 10.2194 17.005L12.5714 19.3101L17.7806 14.205C18.0596 13.9317 18.5118 13.9317 18.7908 14.205Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const resendSubmission = {
  path: () => (
    <>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.5859 3C12.1163 3.00004 12.625 3.2109 13 3.58594L16.4141 7C16.7891 7.37504 17 7.88368 17 8.41406V12.9424C16.136 12.3853 15.105 12.0625 14 12.0625C13.3862 12.0625 12.7955 12.1636 12.2432 12.3477C11.8626 11.8307 11.2493 11.5 10.5713 11.5C9.44969 11.5001 8.5 12.4013 8.5 13.5625V16.375C8.5 16.8613 8.66839 17.3004 8.94434 17.6484C8.72609 18.0511 8.64322 18.5246 8.73242 19H7C5.89543 19 5 18.1046 5 17V5C5 3.89543 5.89543 3 7 3H11.5859ZM8 7C7.44772 7 7 7.44772 7 8C7 8.55229 7.44772 9 8 9H12C12.5523 9 13 8.55229 13 8C13 7.44772 12.5523 7 12 7H8Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.5714 13C10.887 13 11.1429 13.2518 11.1429 13.5625V14.7445C11.8686 14.0152 12.8803 13.5625 14 13.5625C15.7425 13.5625 17.2234 14.659 17.7722 16.1875C17.8774 16.4805 17.7215 16.8018 17.4239 16.9053C17.1264 17.0089 16.7999 16.8554 16.6947 16.5625C16.3022 15.4693 15.2431 14.6875 14 14.6875C13.0658 14.6875 12.2354 15.1291 11.7139 15.8125H13.4286C13.7442 15.8125 14 16.0643 14 16.375C14 16.6857 13.7442 16.9375 13.4286 16.9375H10.5714C10.2558 16.9375 10 16.6857 10 16.375V13.5625C10 13.2518 10.2558 13 10.5714 13ZM10.5761 18.0947C10.8736 17.9911 11.2001 18.1446 11.3053 18.4375C11.6978 19.5307 12.7569 20.3125 14 20.3125C14.9342 20.3125 15.7646 19.8709 16.2861 19.1875H14.5714C14.2558 19.1875 14 18.9357 14 18.625C14 18.3143 14.2558 18.0625 14.5714 18.0625H17.4286C17.5801 18.0625 17.7255 18.1218 17.8326 18.2273C17.9398 18.3327 18 18.4758 18 18.625V21.4375C18 21.7482 17.7442 22 17.4286 22C17.113 22 16.8571 21.7482 16.8571 21.4375V20.2555C16.1314 20.9848 15.1197 21.4375 14 21.4375C12.2575 21.4375 10.7766 20.341 10.2278 18.8125C10.1226 18.5195 10.2785 18.1982 10.5761 18.0947Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const viewSubmission = {
  path: () => (
    <>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.5859 3C11.1163 3.00004 11.625 3.2109 12 3.58594L15.4141 7C15.7891 7.37504 16 7.88368 16 8.41406V13.792C15.3661 13.6022 14.694 13.5 14 13.5C11.0257 13.5 8.45148 15.369 7.5752 18.0312L7.4209 18.5L7.5752 18.9688C7.57864 18.9792 7.58244 18.9896 7.58594 19H6C4.89543 19 4 18.1046 4 17V5C4 3.89543 4.89543 3 6 3H10.5859ZM7 7C6.44772 7 6 7.44772 6 8C6 8.55229 6.44772 9 7 9H11C11.5523 9 12 8.55229 12 8C12 7.44772 11.5523 7 11 7H7Z"
        fill="currentColor"
      />
      <path
        d="M14 19.5C14.5788 19.5 15.048 19.0523 15.048 18.5C15.048 17.9477 14.5788 17.5 14 17.5C13.4212 17.5 12.952 17.9477 12.952 18.5C12.952 19.0523 13.4212 19.5 14 19.5Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9 18.5C9.66769 16.4715 11.6538 15 14 15C16.3462 15 18.3323 16.4714 19 18.5C18.3323 20.5285 16.3462 22 14 22C11.6538 22 9.66771 20.5286 9 18.5ZM16.096 18.5C16.096 19.6046 15.1576 20.5 14 20.5C12.8425 20.5 11.9041 19.6046 11.9041 18.5C11.9041 17.3954 12.8425 16.5 14 16.5C15.1576 16.5 16.096 17.3954 16.096 18.5Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const deleteSubmission = {
  path: () => (
    <>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.5859 3C12.1163 3.00004 12.625 3.2109 13 3.58594L16.4141 7C16.7891 7.37504 17 7.88368 17 8.41406V11.5547L16.9844 11.5273C16.5921 10.8817 15.8904 10.5001 15.1504 10.5H13.8643C13.124 10.5 12.4216 10.8814 12.0293 11.5273L11.9551 11.6592L11.9082 11.75H10.002C9.22644 11.75 8.58793 12.3386 8.50977 13.0938L8.50195 13.2471V13.3936C8.50177 13.4838 8.50122 13.6084 8.50098 13.7432C8.50049 14.0122 8.5 14.3259 8.5 14.5C8.5 15.0128 8.75781 15.4648 9.15039 15.7354V19H7C5.89543 19 5 18.1046 5 17V5C5 3.89543 5.89543 3 7 3H11.5859ZM8 7C7.44772 7 7 7.44772 7 8C7 8.55229 7.44772 9 8 9H12C12.5523 9 13 8.55229 13 8C13 7.44772 12.5523 7 12 7H8Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.8571 12C13.6136 12 13.391 12.1338 13.2822 12.3455L12.817 13.25H10.6429C10.2878 13.25 10 13.5298 10 13.875C10 14.2202 10.2878 14.5 10.6429 14.5L10.6429 20.75C10.6429 21.4404 11.2185 22 11.9286 22H17.0714C17.7815 22 18.3571 21.4404 18.3571 20.75V14.5C18.7122 14.5 19 14.2202 19 13.875C19 13.5298 18.7122 13.25 18.3571 13.25H16.183L15.7178 12.3455C15.609 12.1338 15.3864 12 15.1429 12H13.8571ZM12.5714 15.75C12.5714 15.4048 12.8592 15.125 13.2143 15.125C13.5693 15.125 13.8571 15.4048 13.8571 15.75V19.5C13.8571 19.8452 13.5693 20.125 13.2143 20.125C12.8592 20.125 12.5714 19.8452 12.5714 19.5V15.75ZM15.7857 15.125C15.4307 15.125 15.1429 15.4048 15.1429 15.75V19.5C15.1429 19.8452 15.4307 20.125 15.7857 20.125C16.1408 20.125 16.4286 19.8452 16.4286 19.5V15.75C16.4286 15.4048 16.1408 15.125 15.7857 15.125Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const resources = {
  path: () => (
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.5859 4C13.1163 4.00004 13.625 4.2109 14 4.58594L17.4141 8C17.7891 8.37504 18 8.88368 18 9.41406V18C18 19.1046 17.1046 20 16 20H8C6.89543 20 6 19.1046 6 18V6C6 4.89543 6.89543 4 8 4H12.5859ZM8.57129 15.875C8.25576 15.8751 8 16.1269 8 16.4375C8 16.7481 8.25576 16.9999 8.57129 17H15.4287C15.7442 16.9999 16 16.7481 16 16.4375C16 16.1269 15.7442 15.8751 15.4287 15.875H8.57129ZM12 8C11.8484 8 11.7029 8.05955 11.5957 8.16504L9.88184 9.85254C9.65875 10.0722 9.65875 10.4278 9.88184 10.6475C10.105 10.8671 10.4663 10.8671 10.6895 10.6475L11.4287 9.9209V14.1875C11.4287 14.4982 11.6844 14.75 12 14.75C12.3156 14.75 12.5713 14.4982 12.5713 14.1875V9.9209L13.3105 10.6475C13.5337 10.8671 13.895 10.8671 14.1182 10.6475C14.3413 10.4278 14.3413 10.0722 14.1182 9.85254L12.4043 8.16504C12.2971 8.05955 12.1516 8 12 8Z"
      fill="currentColor"
    />
  ),
  outline: false,
};

export const viewWebhook = {
  path: () => (
    <>
      <path
        d="M10.6668 12.3337C11.0527 12.3337 11.3655 12.0352 11.3655 11.667C11.3655 11.2988 11.0527 11.0003 10.6668 11.0003C10.281 11.0003 9.96819 11.2988 9.96819 11.667C9.96819 12.0352 10.281 12.3337 10.6668 12.3337Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.3335 11.667C7.77863 10.3146 9.10267 9.33366 10.6668 9.33366C12.231 9.33366 13.555 10.3146 14.0002 11.667C13.555 13.0194 12.231 14.0003 10.6668 14.0003C9.10268 14.0003 7.77863 13.0194 7.3335 11.667ZM12.0641 11.667C12.0641 12.4034 11.4386 13.0003 10.6668 13.0003C9.89514 13.0003 9.26954 12.4034 9.26954 11.667C9.26954 10.9306 9.89514 10.3337 10.6668 10.3337C11.4386 10.3337 12.0641 10.9306 12.0641 11.667Z"
        fill="currentColor"
      />
      <path
        d="M3.75798 9.33301C3.40444 9.45231 3.1135 9.6661 2.88623 9.97428C2.65911 10.2824 2.54574 10.6303 2.54574 11.0179C2.54574 11.5149 2.72221 11.9376 3.07568 12.2855C3.42922 12.6334 3.85904 12.8076 4.3641 12.8076C4.86903 12.8076 5.33363 12.6669 6.00016 12.0003L6.66683 13.0003C6.00025 13.6669 5.10141 14.0002 4.3641 14.0003C3.52571 14.0003 2.81047 13.7095 2.21956 13.1279C1.62877 12.5464 1.3335 11.843 1.3335 11.0179C1.3335 10.2922 1.56344 9.65864 2.02295 9.11686C2.48255 8.57505 3.06101 8.23456 3.75798 8.09538V9.33301Z"
        fill="currentColor"
      />
      <path
        d="M7.69743 2.66699C8.53568 2.66706 9.25047 2.95788 9.84131 3.53939C10.4321 4.12093 10.7274 4.82434 10.7274 5.64941H9.51514C9.51513 5.15238 9.33868 4.72977 8.98519 4.38184C8.63172 4.03395 8.20235 3.85977 7.69743 3.8597C7.19238 3.8597 6.76255 4.03388 6.40902 4.38184C6.05555 4.72976 5.87908 5.15239 5.87907 5.64941C5.87907 6.07684 6.01039 6.45199 6.27295 6.77506C6.53558 7.09816 6.86891 7.30473 7.27295 7.39421L5.22738 10.7497C5.24754 10.7993 5.26009 10.8441 5.26514 10.8838C5.27018 10.9235 5.27295 10.9682 5.27295 11.0179C5.27294 11.2663 5.18456 11.4774 5.00798 11.6514C4.83128 11.8253 4.61649 11.9124 4.3641 11.9124C4.11157 11.9124 3.89633 11.8253 3.71956 11.6514C3.543 11.4775 3.4546 11.2663 3.45459 11.0179C3.45459 10.7993 3.52551 10.6105 3.66683 10.4515C3.80819 10.2925 3.97989 10.1881 4.1818 10.1383L5.60628 7.81152C5.3134 7.54312 5.08348 7.22269 4.91683 6.84993C4.75016 6.47713 4.66683 6.0769 4.66683 5.64941C4.66684 4.82436 4.96211 4.12093 5.5529 3.53939C6.14381 2.95781 6.85904 2.66699 7.69743 2.66699Z"
        fill="currentColor"
      />
      <path
        d="M7.69743 4.75488C7.94983 4.75495 8.16461 4.84204 8.34131 5.01595C8.5179 5.18987 8.60627 5.40101 8.60628 5.64941V5.77637C8.60625 5.81109 8.59581 5.85311 8.57568 5.90267L10.0216 8.37923C9.61402 8.43593 9.22267 8.54452 8.85628 8.70019L7.53076 6.52897C7.31864 6.48921 7.14158 6.38986 7.00016 6.23079C6.85883 6.07175 6.78792 5.87801 6.78792 5.64941C6.78793 5.40103 6.87633 5.18987 7.0529 5.01595C7.22966 4.84197 7.4449 4.75488 7.69743 4.75488Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const createWebhook = {
  path: () => (
    <>
      <path
        d="M3.75798 8.66602C3.40444 8.78531 3.1135 8.9991 2.88623 9.30729C2.65911 9.6154 2.54574 9.96333 2.54574 10.3509C2.54574 10.8479 2.72221 11.2706 3.07568 11.6185C3.42922 11.9664 3.85904 12.1406 4.3641 12.1406C4.86903 12.1406 5.33363 11.9999 6.00016 11.3333L6.5848 12.2103C6.6045 12.242 6.62492 12.2731 6.64665 12.3034L6.66683 12.3333C6.00025 12.9999 5.10141 13.3332 4.3641 13.3333C3.52571 13.3333 2.81047 13.0425 2.21956 12.4609C1.62877 11.8794 1.3335 11.176 1.3335 10.3509C1.3335 9.62525 1.56344 8.99165 2.02295 8.44987C2.48255 7.90806 3.06101 7.56757 3.75798 7.42839V8.66602Z"
        fill="currentColor"
      />
      <path
        d="M7.69743 2C8.53568 2.00007 9.25047 2.29089 9.84131 2.8724C10.4321 3.45394 10.7274 4.15735 10.7274 4.98242H9.51514C9.51513 4.48539 9.33868 4.06278 8.98519 3.71484C8.63172 3.36696 8.20235 3.19278 7.69743 3.19271C7.19238 3.19271 6.76255 3.36689 6.40902 3.71484C6.05555 4.06277 5.87908 4.4854 5.87907 4.98242C5.87907 5.40985 6.01039 5.785 6.27295 6.10807C6.53558 6.43117 6.86891 6.63774 7.27295 6.72721L5.22738 10.0827C5.24754 10.1323 5.26009 10.1771 5.26514 10.2168C5.27018 10.2565 5.27295 10.3012 5.27295 10.3509C5.27294 10.5993 5.18456 10.8105 5.00798 10.9844C4.83128 11.1583 4.61649 11.2454 4.3641 11.2454C4.11157 11.2454 3.89633 11.1584 3.71956 10.9844C3.543 10.8105 3.4546 10.5993 3.45459 10.3509C3.45459 10.1323 3.52551 9.94354 3.66683 9.78451C3.80819 9.6255 3.97989 9.52109 4.1818 9.47135L5.60628 7.14453C5.3134 6.87613 5.08348 6.5557 4.91683 6.18294C4.75016 5.81014 4.66683 5.40991 4.66683 4.98242C4.66684 4.15737 4.96211 3.45394 5.5529 2.8724C6.14381 2.29082 6.85904 2 7.69743 2Z"
        fill="currentColor"
      />
      <path
        d="M7.69743 4.08789C7.94983 4.08796 8.16461 4.17505 8.34131 4.34896C8.5179 4.52288 8.60627 4.73402 8.60628 4.98242V5.10938C8.60625 5.1441 8.59581 5.18612 8.57568 5.23568L9.75667 7.25781L9.00016 8.33333L7.53076 5.86198C7.31864 5.82221 7.14158 5.72287 7.00016 5.5638C6.85883 5.40476 6.78792 5.21101 6.78792 4.98242C6.78793 4.73403 6.87633 4.52287 7.0529 4.34896C7.22966 4.17498 7.4449 4.08789 7.69743 4.08789Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.6668 8C11.035 8 11.3335 8.29848 11.3335 8.66667V10.6667H13.3335C13.7017 10.6667 14.0002 10.9651 14.0002 11.3333C14.0002 11.7015 13.7017 12 13.3335 12H11.3335V14C11.3335 14.3682 11.035 14.6667 10.6668 14.6667C10.2986 14.6667 10.0002 14.3682 10.0002 14V12H8.00016C7.63197 12 7.3335 11.7015 7.3335 11.3333C7.3335 10.9651 7.63197 10.6667 8.00016 10.6667H10.0002V8.66667C10.0002 8.29848 10.2986 8 10.6668 8Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const editWebhook = {
  path: () => (
    <>
      <path
        d="M12.3743 8.27895C12.7463 7.90702 13.3493 7.90702 13.7212 8.27895C14.0931 8.65087 14.0931 9.25389 13.7212 9.62582L13.3436 10.0034L11.9968 8.65651L12.3743 8.27895Z"
        fill="currentColor"
      />
      <path d="M11.3233 9.32995L7.3335 13.3198V14.6667H8.68036L12.6702 10.6768L11.3233 9.32995Z" fill="currentColor" />
      <path
        d="M3.79053 8.75521C3.43228 8.8761 3.13737 9.09265 2.90706 9.40495C2.67696 9.71714 2.56202 10.0695 2.56201 10.4622C2.56202 10.9659 2.74094 11.3942 3.09912 11.7467C3.45734 12.0993 3.89275 12.276 4.40446 12.276C4.91613 12.276 5.38724 12.1331 6.06266 11.4577L6.73779 12.4714C6.06235 13.1467 5.15154 13.4843 4.40446 13.4844C3.55492 13.4844 2.83006 13.1896 2.23128 12.6003C1.6327 12.011 1.3335 11.2982 1.3335 10.4622C1.3335 9.72691 1.56643 9.08481 2.03206 8.53581C2.49779 7.98677 3.08426 7.64169 3.79053 7.50065V8.75521Z"
        fill="currentColor"
      />
      <path
        d="M7.78206 2C8.63148 2.00007 9.35588 2.29487 9.95459 2.88411C10.5533 3.4734 10.8524 4.18609 10.8524 5.02214H9.62451C9.62449 4.51852 9.44555 4.09018 9.0874 3.73763C8.72922 3.38511 8.29372 3.2084 7.78206 3.20833C7.2704 3.20838 6.83491 3.38512 6.47673 3.73763C6.11855 4.09019 5.93964 4.51851 5.93962 5.02214C5.93962 5.45522 6.0727 5.83541 6.3387 6.16276C6.60483 6.49017 6.94295 6.6997 7.35238 6.79036L5.27946 10.1908C5.29979 10.2409 5.31276 10.286 5.31787 10.3262C5.32298 10.3664 5.32568 10.4119 5.32568 10.4622C5.32568 10.714 5.23575 10.9279 5.0568 11.1042C4.87776 11.2803 4.66018 11.3684 4.40446 11.3685C4.14861 11.3685 3.93057 11.2804 3.75146 11.1042C3.57254 10.9279 3.48259 10.7139 3.48258 10.4622C3.48259 10.2407 3.55488 10.0492 3.69808 9.88802C3.84124 9.72708 4.01514 9.62135 4.21956 9.57096L5.66357 7.21289C5.36681 6.94093 5.13323 6.61663 4.96436 6.23893C4.79547 5.86115 4.7111 5.45532 4.7111 5.02214C4.71112 4.18619 5.01035 3.47336 5.60889 2.88411C6.20762 2.29483 6.9326 2.00005 7.78206 2Z"
        fill="currentColor"
      />
      <path
        d="M7.78206 4.11589C8.03783 4.11595 8.256 4.20398 8.43506 4.38021C8.61391 4.55641 8.70327 4.7705 8.70329 5.02214V5.15104C8.70321 5.18617 8.69237 5.22856 8.67204 5.27865L10.5757 8.44727C10.5556 8.46134 10.5357 8.47585 10.5164 8.49154L10.4403 8.56055L9.66683 9.33333L7.61344 5.91341C7.39849 5.87312 7.21898 5.77251 7.07568 5.61133C6.93247 5.45017 6.86084 5.25377 6.86084 5.02214C6.86086 4.77046 6.95017 4.55643 7.12907 4.38021C7.30814 4.20396 7.52627 4.11594 7.78206 4.11589Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const deleteWebhook = {
  path: () => (
    <>
      <path
        d="M7.69743 2C8.53568 2.00007 9.25047 2.29089 9.84131 2.8724C10.4321 3.45394 10.7274 4.15735 10.7274 4.98242H9.51514C9.51513 4.48539 9.33868 4.06278 8.98519 3.71484C8.63172 3.36696 8.20235 3.19278 7.69743 3.19271C7.19238 3.19271 6.76255 3.36689 6.40902 3.71484C6.05555 4.06277 5.87908 4.4854 5.87907 4.98242C5.87907 5.40985 6.01039 5.785 6.27295 6.10807C6.53558 6.43117 6.86891 6.63774 7.27295 6.72721L5.22738 10.0827C5.24754 10.1323 5.26009 10.1771 5.26514 10.2168C5.27018 10.2565 5.27295 10.3012 5.27295 10.3509C5.27294 10.5993 5.18456 10.8105 5.00798 10.9844C4.83128 11.1583 4.61649 11.2454 4.3641 11.2454C4.11157 11.2454 3.89633 11.1584 3.71956 10.9844C3.543 10.8105 3.4546 10.5993 3.45459 10.3509C3.45459 10.1323 3.52551 9.94354 3.66683 9.78451C3.80819 9.6255 3.97989 9.52109 4.1818 9.47135L5.60628 7.14453C5.3134 6.87613 5.08348 6.5557 4.91683 6.18294C4.75016 5.81014 4.66683 5.40991 4.66683 4.98242C4.66684 4.15737 4.96211 3.45394 5.5529 2.8724C6.14381 2.29082 6.85904 2 7.69743 2Z"
        fill="currentColor"
      />
      <path
        d="M3.75798 8.66602C3.40444 8.78531 3.1135 8.9991 2.88623 9.30729C2.65911 9.6154 2.54574 9.96333 2.54574 10.3509C2.54574 10.8479 2.72221 11.2706 3.07568 11.6185C3.42922 11.9664 3.85904 12.1406 4.3641 12.1406C4.86902 12.1406 5.29839 11.9664 5.65186 11.6185C6.00535 11.2706 6.1818 10.8479 6.1818 10.3509H7.39079C7.39079 10.3509 7.47491 10.2613 7.3335 10.9473C7.19208 11.6332 6.84623 12.2026 6.29574 12.6549C5.7453 13.1072 5.10135 13.3333 4.3641 13.3333C3.52571 13.3333 2.81047 13.0425 2.21956 12.4609C1.62877 11.8794 1.3335 11.176 1.3335 10.3509C1.3335 9.62525 1.56344 8.99165 2.02295 8.44987C2.48255 7.90806 3.06101 7.56757 3.75798 7.42839V8.66602Z"
        fill="currentColor"
      />
      <path
        d="M7.69743 4.08789C7.94983 4.08796 8.16461 4.17505 8.34131 4.34896C8.5179 4.52288 8.60627 4.73402 8.60628 4.98242V5.10938C8.60625 5.1441 8.59581 5.18612 8.57568 5.23568L9.66683 7L8.91227 8.07878L7.53076 5.86198C7.31864 5.82221 7.14158 5.72287 7.00016 5.5638C6.85883 5.40476 6.78792 5.21101 6.78792 4.98242C6.78793 4.73403 6.87633 4.52287 7.0529 4.34896C7.22966 4.17498 7.4449 4.08789 7.69743 4.08789Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.5716 8C10.4093 8 10.2609 8.08917 10.1883 8.23033L9.87815 8.83333H8.42873C8.19204 8.83333 8.00016 9.01988 8.00016 9.25C8.00016 9.48012 8.19204 9.66667 8.42873 9.66667V13.8333C8.42873 14.2936 8.81249 14.6667 9.28588 14.6667H12.7144C13.1878 14.6667 13.5716 14.2936 13.5716 13.8333V9.66667C13.8083 9.66667 14.0002 9.48012 14.0002 9.25C14.0002 9.01988 13.8083 8.83333 13.5716 8.83333H12.1222L11.8121 8.23033C11.7395 8.08917 11.5911 8 11.4287 8H10.5716ZM9.71445 10.5C9.71445 10.2699 9.90633 10.0833 10.143 10.0833C10.3797 10.0833 10.5716 10.2699 10.5716 10.5V13C10.5716 13.2301 10.3797 13.4167 10.143 13.4167C9.90633 13.4167 9.71445 13.2301 9.71445 13V10.5ZM11.8573 10.0833C11.6206 10.0833 11.4287 10.2699 11.4287 10.5V13C11.4287 13.2301 11.6206 13.4167 11.8573 13.4167C12.094 13.4167 12.2859 13.2301 12.2859 13V10.5C12.2859 10.2699 12.094 10.0833 11.8573 10.0833Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const viewDataSource = {
  path: () => (
    <>
      <path
        d="M3 13C3 14.6569 6.13401 16 10 16C10.0065 16 10.013 15.999 10.0195 15.999C9.84255 16.3268 9.69349 16.6719 9.5752 17.0312L9.4209 17.5L9.5752 17.9688C9.69331 18.3276 9.84291 18.6716 10.0195 18.999C10.013 18.999 10.0065 19 10 19C6.13401 19 3 17.6569 3 16V13Z"
        fill="currentColor"
      />
      <path
        d="M17 11C17 11.5475 16.6564 12.0591 16.0586 12.501C16.0391 12.5008 16.0196 12.5 16 12.5C14.435 12.5 12.9806 13.0173 11.8262 13.8955C11.2439 13.9628 10.6318 14 10 14C6.13401 14 3 12.6569 3 11V8C3 9.65685 6.13401 11 10 11C13.866 11 17 9.65685 17 8V11Z"
        fill="currentColor"
      />
      <path
        d="M10 3C13.866 3 17 4.34315 17 6C17 7.65685 13.866 9 10 9C6.13401 9 3 7.65685 3 6C3 4.34315 6.13401 3 10 3Z"
        fill="currentColor"
      />
      <path
        d="M16 18.5C16.5788 18.5 17.048 18.0523 17.048 17.5C17.048 16.9477 16.5788 16.5 16 16.5C15.4212 16.5 14.952 16.9477 14.952 17.5C14.952 18.0523 15.4212 18.5 16 18.5Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11 17.5C11.6677 15.4715 13.6538 14 16 14C18.3462 14 20.3323 15.4714 21 17.5C20.3323 19.5285 18.3462 21 16 21C13.6538 21 11.6677 19.5286 11 17.5ZM18.096 17.5C18.096 18.6046 17.1576 19.5 16 19.5C14.8425 19.5 13.9041 18.6046 13.9041 17.5C13.9041 16.3954 14.8425 15.5 16 15.5C17.1576 15.5 18.096 16.3954 18.096 17.5Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const createDataSource = {
  path: () => (
    <>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16 11C16.5523 11 17 11.4477 17 12V15H20C20.5523 15 21 15.4477 21 16C21 16.5523 20.5523 17 20 17H17V20C17 20.5523 16.5523 21 16 21C15.4477 21 15 20.5523 15 20V17H12C11.4477 17 11 16.5523 11 16C11 15.4477 11.4477 15 12 15H15V12C15 11.4477 15.4477 11 16 11Z"
        fill="currentColor"
      />
      <path
        d="M3 13C3 14.5848 5.86738 15.8813 9.5 15.9912C9.49999 15.9941 9.5 15.9971 9.5 16C9.5 17.3807 10.6193 18.5 12 18.5H13.5V18.5967C12.4703 18.852 11.2752 19 10 19C6.13401 19 3 17.6569 3 16V13Z"
        fill="currentColor"
      />
      <path
        d="M3 8C3 9.65685 6.13401 11 10 11C11.5058 11 12.9002 10.795 14.042 10.4482C13.7035 10.8747 13.5 11.4132 13.5 12V13.5H12C11.444 13.5 10.9318 13.6833 10.5166 13.9902C10.346 13.9956 10.1738 14 10 14C6.13401 14 3 12.6569 3 11V8Z"
        fill="currentColor"
      />
      <path
        d="M17 9.70898C16.71 9.58222 16.3916 9.5094 16.0566 9.50195C16.6556 9.05979 17 8.54808 17 8V9.70898Z"
        fill="currentColor"
      />
      <path
        d="M10 3C13.866 3 17 4.34315 17 6C17 7.65685 13.866 9 10 9C6.13401 9 3 7.65685 3 6C3 4.34315 6.13401 3 10 3Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const updateDatasource = {
  path: () => (
    <>
      <path
        d="M3 13C3 14.6415 6.07612 15.9734 9.89258 15.998C9.64104 16.4806 9.55806 17.0532 9.7041 17.6221L9.70508 17.623C9.82917 18.1051 10.0084 18.5649 10.2334 18.9971C10.1559 18.9982 10.0781 19 10 19C6.13401 19 3 17.6569 3 16V13Z"
        fill="currentColor"
      />
      <path
        d="M3 8C3 9.60562 5.94319 10.9166 9.64355 10.9961C9.5521 11.2434 9.50005 11.51 9.5 11.7891V13.9912C5.86738 13.8813 3 12.5848 3 11V8Z"
        fill="currentColor"
      />
      <path
        d="M15.4658 12.6211L15.293 12.6523C15.3501 12.6403 15.4077 12.6302 15.4658 12.6211L15.6416 12.5977C15.5825 12.6038 15.524 12.612 15.4658 12.6211Z"
        fill="currentColor"
      />
      <path
        d="M12.0967 11.0615L12.1191 11.0732C12.0934 11.0614 12.0672 11.0501 12.04 11.041C12.0592 11.0474 12.0782 11.0537 12.0967 11.0615Z"
        fill="currentColor"
      />
      <path
        d="M17 9.57715C16.6928 9.52972 16.3785 9.5038 16.0586 9.50098C16.6564 9.05911 17 8.54755 17 8V9.57715Z"
        fill="currentColor"
      />
      <path
        d="M10 3C13.866 3 17 4.34315 17 6C17 7.65685 13.866 9 10 9C6.13401 9 3 7.65685 3 6C3 4.34315 6.13401 3 10 3Z"
        fill="currentColor"
      />
      <path
        d="M19.4211 20.2105V19.6451C18.527 20.4847 17.3243 21 16 21C13.6691 21 11.7123 19.4053 11.1573 17.249C11.0489 16.8269 11.3036 16.3965 11.7257 16.2878C12.1479 16.1794 12.5782 16.4342 12.6869 16.8563C13.0669 18.3317 14.4072 19.4211 16 19.4211C16.9692 19.4211 17.8442 19.0171 18.4671 18.3684H17.5789C17.1429 18.3684 16.7895 18.015 16.7895 17.5789C16.7895 17.1429 17.1429 16.7895 17.5789 16.7895H20.2105C20.6465 16.7895 21 17.1429 21 17.5789V20.2105C21 20.6465 20.6465 21 20.2105 21C19.7745 21 19.4211 20.6465 19.4211 20.2105ZM16 11C18.3309 11 20.2877 12.5947 20.8427 14.751C20.9511 15.1731 20.6964 15.6035 20.2743 15.7122C19.8521 15.8206 19.4218 15.5658 19.3131 15.1437C18.9331 13.6683 17.5928 12.5789 16 12.5789C15.0308 12.5789 14.1558 12.9829 13.5329 13.6316H14.4211C14.8571 13.6316 15.2105 13.985 15.2105 14.4211C15.2105 14.8571 14.8571 15.2105 14.4211 15.2105H11.7895C11.3535 15.2105 11 14.8571 11 14.4211V11.7895C11 11.3535 11.3535 11 11.7895 11C12.2255 11 12.5789 11.3535 12.5789 11.7895V12.3549C13.473 11.5153 14.6757 11 16 11Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const deleteDataSource = {
  path: () => (
    <>
      <path
        d="M3 13C3 14.6569 6.13401 16 10 16C10.3891 16 10.7708 15.9861 11.1426 15.96V18.96C10.7708 18.9861 10.3891 19 10 19C6.13401 19 3 17.6569 3 16V13Z"
        fill="currentColor"
      />
      <path
        d="M3 8C3 9.65685 6.13401 11 10 11C10.6545 11 11.2878 10.9597 11.8887 10.8877C11.0935 11.1855 10.5 11.9404 10.5 12.875C10.5 13.2857 10.6167 13.6605 10.8125 13.9785C10.5459 13.9917 10.2748 14 10 14C6.13401 14 3 12.6569 3 11V8Z"
        fill="currentColor"
      />
      <path d="M17 9.5H16.0605C16.6573 9.05842 17 8.54702 17 8V9.5Z" fill="currentColor" />
      <path
        d="M10 3C13.866 3 17 4.34315 17 6C17 7.65685 13.866 9 10 9C6.13401 9 3 7.65685 3 6C3 4.34315 6.13401 3 10 3Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.8571 11C15.6136 11 15.391 11.1338 15.2822 11.3455L14.817 12.25H12.6429C12.2878 12.25 12 12.5298 12 12.875C12 13.2202 12.2878 13.5 12.6429 13.5V19.75C12.6429 20.4404 13.2185 21 13.9286 21H19.0714C19.7815 21 20.3571 20.4404 20.3571 19.75V13.5C20.7122 13.5 21 13.2202 21 12.875C21 12.5298 20.7122 12.25 20.3571 12.25H18.183L17.7178 11.3455C17.609 11.1338 17.3864 11 17.1429 11H15.8571ZM14.5714 14.75C14.5714 14.4048 14.8592 14.125 15.2143 14.125C15.5693 14.125 15.8571 14.4048 15.8571 14.75V18.5C15.8571 18.8452 15.5693 19.125 15.2143 19.125C14.8592 19.125 14.5714 18.8452 14.5714 18.5V14.75ZM17.7857 14.125C17.4307 14.125 17.1429 14.4048 17.1429 14.75V18.5C17.1429 18.8452 17.4307 19.125 17.7857 19.125C18.1408 19.125 18.4286 18.8452 18.4286 18.5V14.75C18.4286 14.4048 18.1408 14.125 17.7857 14.125Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const editDatasource = {
  path: () => (
    <>
      <path
        d="M18.5613 11.4184C19.1192 10.8605 20.0237 10.8605 20.5816 11.4184C21.1395 11.9763 21.1395 12.8808 20.5816 13.4387L20.0152 14.0051L17.9949 11.9848L18.5613 11.4184Z"
        fill="currentColor"
      />
      <path d="M16.9848 12.9949L11 18.9797V21H13.0203L19.0051 15.0152L16.9848 12.9949Z" fill="currentColor" />
      <path
        d="M3 13C3 14.6569 6.13401 16 10 16C10.6897 16 11.3559 15.9556 11.9854 15.876L9.94043 17.918C9.65851 18.1993 9.50005 18.5812 9.5 18.9795V18.9912C5.86738 18.8813 3 17.5848 3 16V13Z"
        fill="currentColor"
      />
      <path
        d="M17 10.8584L16.9346 10.9238C16.8947 10.9637 16.8571 11.0061 16.8223 11.0498L14.6104 13.2559C13.3788 13.7183 11.766 14 10 14C6.13401 14 3 12.6569 3 11V8C3 9.65685 6.13401 11 10 11C13.866 11 17 9.65685 17 8V10.8584Z"
        fill="currentColor"
      />
      <path
        d="M10 3C13.866 3 17 4.34315 17 6C17 7.65685 13.866 9 10 9C6.13401 9 3 7.65685 3 6C3 4.34315 6.13401 3 10 3Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const viewUser = {
  path: () => (
    <>
      <path
        d="M10 3C11.6569 3 13 4.34315 13 6C13 7.65685 11.6569 9 10 9C8.34315 9 7 7.65685 7 6C7 4.34315 8.34315 3 10 3Z"
        fill="currentColor"
      />
      <path
        d="M10 11C11.7241 11 13.3016 11.6246 14.5215 12.6582C12.1982 13.1606 10.3022 14.8224 9.5752 17.0312L9.4209 17.5C9.38477 17.6289 9.3125 17.9094 9.3125 18H3C3 14.134 6.13401 11 10 11Z"
        fill="currentColor"
      />
      <path
        d="M16 18.5C16.5788 18.5 17.048 18.0523 17.048 17.5C17.048 16.9477 16.5788 16.5 16 16.5C15.4212 16.5 14.952 16.9477 14.952 17.5C14.952 18.0523 15.4212 18.5 16 18.5Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11 17.5C11.6677 15.4715 13.6538 14 16 14C18.3462 14 20.3323 15.4714 21 17.5C20.3323 19.5285 18.3462 21 16 21C13.6538 21 11.6677 19.5286 11 17.5ZM18.096 17.5C18.096 18.6046 17.1576 19.5 16 19.5C14.8425 19.5 13.9041 18.6046 13.9041 17.5C13.9041 16.3954 14.8425 15.5 16 15.5C17.1576 15.5 18.096 16.3954 18.096 17.5Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const addUser = {
  path: () => (
    <>
      <path
        d="M10 11C11.2766 11 12.4724 11.3434 13.5029 11.9404C13.5025 11.9602 13.5 11.9801 13.5 12V13.5H12C10.6193 13.5 9.5 14.6193 9.5 16C9.5 16.8193 9.89593 17.544 10.5049 18H3C3 14.134 6.13401 11 10 11Z"
        fill="currentColor"
      />
      <path
        d="M10 3C11.6569 3 13 4.34315 13 6C13 7.65685 11.6569 9 10 9C8.34315 9 7 7.65685 7 6C7 4.34315 8.34315 3 10 3Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16 11C16.5523 11 17 11.4477 17 12V15H20C20.5523 15 21 15.4477 21 16C21 16.5523 20.5523 17 20 17H17V20C17 20.5523 16.5523 21 16 21C15.4477 21 15 20.5523 15 20V17H12C11.4477 17 11 16.5523 11 16C11 15.4477 11.4477 15 12 15H15V12C15 11.4477 15.4477 11 16 11Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const updateUser = {
  path: () => (
    <>
      <path
        d="M11.709 15.2061C11.7353 15.2087 11.762 15.2109 11.7891 15.2109C11.7345 15.2109 11.6813 15.2049 11.6299 15.1943C11.621 15.1925 11.6123 15.1896 11.6035 15.1875C11.6379 15.1957 11.673 15.2024 11.709 15.2061Z"
        fill="currentColor"
      />
      <path
        d="M10 3C11.6569 3 13 4.34315 13 6C13 7.65685 11.6569 9 10 9C8.34315 9 7 7.65685 7 6C7 4.34315 8.34315 3 10 3Z"
        fill="currentColor"
      />
      <path
        d="M19.4211 20.2105V19.6451C18.527 20.4847 17.3243 21 16 21C13.6691 21 11.7123 19.4053 11.1573 17.249C11.0489 16.8269 11.3036 16.3965 11.7257 16.2878C12.1479 16.1794 12.5782 16.4342 12.6869 16.8563C13.0669 18.3317 14.4072 19.4211 16 19.4211C16.9692 19.4211 17.8442 19.0171 18.4671 18.3684H17.5789C17.1429 18.3684 16.7895 18.015 16.7895 17.5789C16.7895 17.1429 17.1429 16.7895 17.5789 16.7895H20.2105C20.6465 16.7895 21 17.1429 21 17.5789V20.2105C21 20.6465 20.6465 21 20.2105 21C19.7745 21 19.4211 20.6465 19.4211 20.2105ZM16 11C18.3309 11 20.2877 12.5947 20.8427 14.751C20.9511 15.1731 20.6964 15.6035 20.2743 15.7122C19.8521 15.8206 19.4218 15.5658 19.3131 15.1437C18.9331 13.6683 17.5928 12.5789 16 12.5789C15.0308 12.5789 14.1558 12.9829 13.5329 13.6316H14.4211C14.8571 13.6316 15.2105 13.985 15.2105 14.4211C15.2105 14.8571 14.8571 15.2105 14.4211 15.2105L11.7891 15.2109C11.353 15.2109 11 14.8571 11 14.4211V11.7895C11 11.3535 11.3535 11 11.7895 11C12.2255 11 12.5789 11.3535 12.5789 11.7895V12.3549C13.473 11.5153 14.6757 11 16 11Z"
        fill="currentColor"
      />
      <path
        d="M9.78642 18H3C3 14.2552 5.80192 11.188 9.5 11C9.5 11 9.0002 12.5 9 14.5C8.99976 16.924 9.78642 18 9.78642 18Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const deleteUser = {
  path: () => (
    <>
      <path
        d="M10 11C10.482 11 10.9526 11.0488 11.4072 11.1416C10.8659 11.5199 10.5 12.1418 10.5 12.875C10.5 13.4816 10.7498 14.013 11.1426 14.3926V18H3C3 14.134 6.13401 11 10 11Z"
        fill="currentColor"
      />
      <path
        d="M10 3C11.6569 3 13 4.34315 13 6C13 7.65685 11.6569 9 10 9C8.34315 9 7 7.65685 7 6C7 4.34315 8.34315 3 10 3Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.8571 11C15.6136 11 15.391 11.1338 15.2822 11.3455L14.817 12.25H12.6429C12.2878 12.25 12 12.5298 12 12.875C12 13.2202 12.2878 13.5 12.6429 13.5V19.75C12.6429 20.4404 13.2185 21 13.9286 21H19.0714C19.7815 21 20.3571 20.4404 20.3571 19.75V13.5C20.7122 13.5 21 13.2202 21 12.875C21 12.5298 20.7122 12.25 20.3571 12.25H18.183L17.7178 11.3455C17.609 11.1338 17.3864 11 17.1429 11H15.8571ZM14.5714 14.75C14.5714 14.4048 14.8592 14.125 15.2143 14.125C15.5693 14.125 15.8571 14.4048 15.8571 14.75V18.5C15.8571 18.8452 15.5693 19.125 15.2143 19.125C14.8592 19.125 14.5714 18.8452 14.5714 18.5V14.75ZM17.7857 14.125C17.4307 14.125 17.1429 14.4048 17.1429 14.75V18.5C17.1429 18.8452 17.4307 19.125 17.7857 19.125C18.1408 19.125 18.4286 18.8452 18.4286 18.5V14.75C18.4286 14.4048 18.1408 14.125 17.7857 14.125Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const editUser = {
  path: () => (
    <>
      <path
        d="M10 3C11.6569 3 13 4.34315 13 6C13 7.65685 11.6569 9 10 9C8.34315 9 7 7.65685 7 6C7 4.34315 8.34315 3 10 3Z"
        fill="currentColor"
      />
      <path
        d="M10 11C11.7241 11 13.3016 11.6246 14.5215 12.6582L9.3125 18H3C3 14.134 6.13401 11 10 11Z"
        fill="currentColor"
      />
      <path
        d="M18.5613 11.4184C19.1192 10.8605 20.0237 10.8605 20.5816 11.4184C21.1395 11.9763 21.1395 12.8808 20.5816 13.4387L20.0152 14.0051L17.9949 11.9848L18.5613 11.4184Z"
        fill="currentColor"
      />
      <path d="M16.9848 12.9949L11 18.9797V21H13.0203L19.0051 15.0152L16.9848 12.9949Z" fill="currentColor" />
    </>
  ),
  outline: false,
};

export const reassign = {
  path: () => (
    <path
      d="M21 12H15M18.5 15L21 12L18.5 9M13 7C13 9.20914 11.2091 11 9 11C6.79086 11 5 9.20914 5 7C5 4.79086 6.79086 3 9 3C11.2091 3 13 4.79086 13 7ZM3 20C3 16.6863 5.68629 14 9 14C12.3137 14 15 16.6863 15 20V21H3V20Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  ),
  outline: true,
};

export const userPermission = {
  path: () => (
    <>
      <mask
        id="path-1-outside-1_27799_28615"
        maskUnits="userSpaceOnUse"
        x="2"
        y="0"
        width="20"
        height="23"
        fill="black"
      >
        <rect fill="white" x="2" width="20" height="23" />
        <path d="M11 10C11.482 10 11.9526 10.0488 12.4072 10.1416C12.658 10.1928 12.9906 10.2705 13.3633 10.3643C11.9395 11.3033 11 12.9169 11 14.75C11 14.9495 11.0143 15.1464 11.0361 15.3408L9.37891 17H4C4 13.134 7.13401 10 11 10Z" />
        <path d="M11 2C12.6569 2 14 3.34315 14 5C14 6.65685 12.6569 8 11 8C9.34315 8 8 6.65685 8 5C8 3.34315 9.34315 2 11 2Z" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20 14.75C20 16.8211 18.3211 18.5 16.25 18.5C15.8711 18.5 15.5054 18.4438 15.1607 18.3393L13.75 19.75H12.5V21H10V18.5L12.6607 15.8393C12.5562 15.4946 12.5 15.1289 12.5 14.75C12.5 12.6789 14.1789 11 16.25 11C18.3211 11 20 12.6789 20 14.75ZM16.25 12.25C15.9048 12.25 15.625 12.5298 15.625 12.875C15.625 13.2202 15.9048 13.5 16.25 13.5C16.9404 13.5 17.5 14.0596 17.5 14.75C17.5 15.0952 17.7798 15.375 18.125 15.375C18.4702 15.375 18.75 15.0952 18.75 14.75C18.75 13.3693 17.6307 12.25 16.25 12.25Z"
        />
      </mask>
      <path
        d="M11 10C11.482 10 11.9526 10.0488 12.4072 10.1416C12.658 10.1928 12.9906 10.2705 13.3633 10.3643C11.9395 11.3033 11 12.9169 11 14.75C11 14.9495 11.0143 15.1464 11.0361 15.3408L9.37891 17H4C4 13.134 7.13401 10 11 10Z"
        fill="currentColor"
      />
      <path
        d="M11 2C12.6569 2 14 3.34315 14 5C14 6.65685 12.6569 8 11 8C9.34315 8 8 6.65685 8 5C8 3.34315 9.34315 2 11 2Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20 14.75C20 16.8211 18.3211 18.5 16.25 18.5C15.8711 18.5 15.5054 18.4438 15.1607 18.3393L13.75 19.75H12.5V21H10V18.5L12.6607 15.8393C12.5562 15.4946 12.5 15.1289 12.5 14.75C12.5 12.6789 14.1789 11 16.25 11C18.3211 11 20 12.6789 20 14.75ZM16.25 12.25C15.9048 12.25 15.625 12.5298 15.625 12.875C15.625 13.2202 15.9048 13.5 16.25 13.5C16.9404 13.5 17.5 14.0596 17.5 14.75C17.5 15.0952 17.7798 15.375 18.125 15.375C18.4702 15.375 18.75 15.0952 18.75 14.75C18.75 13.3693 17.6307 12.25 16.25 12.25Z"
        fill="currentColor"
      />
      <path
        d="M12.4072 10.1416L12.1073 11.6113L12.4072 10.1416ZM13.3633 10.3643L14.1891 11.6164C14.6855 11.289 14.9417 10.6993 14.8421 10.1131C14.7425 9.52683 14.306 9.05476 13.7294 8.90962L13.3633 10.3643ZM11.0361 15.3408L12.0974 16.4009C12.4197 16.0782 12.5777 15.6264 12.5267 15.1732L11.0361 15.3408ZM9.37891 17V18.5C9.77704 18.5 10.1588 18.3417 10.4402 18.06L9.37891 17ZM4 17H2.5C2.5 17.8284 3.17157 18.5 4 18.5V17ZM15.1607 18.3393L15.5958 16.9038L14.7356 16.6431L14.1 17.2787L15.1607 18.3393ZM13.75 19.75V21.25H14.3713L14.8107 20.8107L13.75 19.75ZM12.5 19.75V18.25H11V19.75H12.5ZM12.5 21V22.5H14V21H12.5ZM10 21H8.5V22.5H10V21ZM10 18.5L8.93934 17.4393L8.5 17.8787V18.5H10ZM12.6607 15.8393L13.7213 16.9L14.3569 16.2644L14.0962 15.4042L12.6607 15.8393ZM11 10V11.5C11.3805 11.5 11.7506 11.5385 12.1073 11.6113L12.4072 10.1416L12.7072 8.6719C12.1546 8.55913 11.5836 8.5 11 8.5V10ZM12.4072 10.1416L12.1073 11.6113C12.3271 11.6562 12.6356 11.7279 12.9972 11.8189L13.3633 10.3643L13.7294 8.90962C13.3456 8.81302 12.9889 8.72939 12.7072 8.6719L12.4072 10.1416ZM13.3633 10.3643L12.5374 9.11208C10.7107 10.3168 9.5 12.3916 9.5 14.75H11H12.5C12.5 13.4422 13.1683 12.2897 14.1891 11.6164L13.3633 10.3643ZM11 14.75H9.5C9.5 15.0203 9.51932 15.2753 9.54552 15.5084L11.0361 15.3408L12.5267 15.1732C12.5092 15.0176 12.5 14.8788 12.5 14.75H11ZM11.0361 15.3408L9.97485 14.2808L8.31762 15.94L9.37891 17L10.4402 18.06L12.0974 16.4009L11.0361 15.3408ZM9.37891 17V15.5H4V17V18.5H9.37891V17ZM4 17H5.5C5.5 13.9624 7.96243 11.5 11 11.5V10V8.5C6.30558 8.5 2.5 12.3056 2.5 17H4ZM11 2V3.5C11.8284 3.5 12.5 4.17157 12.5 5H14H15.5C15.5 2.51472 13.4853 0.5 11 0.5V2ZM14 5H12.5C12.5 5.82843 11.8284 6.5 11 6.5V8V9.5C13.4853 9.5 15.5 7.48528 15.5 5H14ZM11 8V6.5C10.1716 6.5 9.5 5.82843 9.5 5H8H6.5C6.5 7.48528 8.51472 9.5 11 9.5V8ZM8 5H9.5C9.5 4.17157 10.1716 3.5 11 3.5V2V0.5C8.51472 0.5 6.5 2.51472 6.5 5H8ZM20 14.75H18.5C18.5 15.9926 17.4926 17 16.25 17V18.5V20C19.1495 20 21.5 17.6495 21.5 14.75H20ZM16.25 18.5V17C16.0202 17 15.801 16.966 15.5958 16.9038L15.1607 18.3393L14.7256 19.7748C15.2098 19.9216 15.7221 20 16.25 20V18.5ZM13.75 19.75V18.25H12.5V19.75V21.25H13.75V19.75ZM12.5 19.75H11V21H12.5H14V19.75H12.5ZM12.5 21V19.5H10V21V22.5H12.5V21ZM10 21H11.5V18.5H10H8.5V21H10ZM10 18.5L11.0607 19.5607L13.7213 16.9L12.6607 15.8393L11.6 14.7787L8.93934 17.4393L10 18.5ZM12.6607 15.8393L14.0962 15.4042C14.034 15.199 14 14.9798 14 14.75H12.5H11C11 15.2779 11.0784 15.7902 11.2252 16.2744L12.6607 15.8393ZM12.5 14.75H14C14 13.5074 15.0074 12.5 16.25 12.5V11V9.5C13.3505 9.5 11 11.8505 11 14.75H12.5ZM16.25 11V12.5C17.4926 12.5 18.5 13.5074 18.5 14.75H20H21.5C21.5 11.8505 19.1495 9.5 16.25 9.5V11ZM16.25 12.25V10.75C15.0764 10.75 14.125 11.7014 14.125 12.875H15.625H17.125C17.125 13.3582 16.7332 13.75 16.25 13.75V12.25ZM15.625 12.875H14.125C14.125 14.0486 15.0764 15 16.25 15V13.5V12C16.7332 12 17.125 12.3918 17.125 12.875H15.625ZM16.25 13.5V15C16.1119 15 16 14.8881 16 14.75H17.5H19C19 13.2312 17.7688 12 16.25 12V13.5ZM17.5 14.75H16C16 15.9236 16.9514 16.875 18.125 16.875V15.375V13.875C18.6082 13.875 19 14.2668 19 14.75H17.5ZM18.125 15.375V16.875C19.2986 16.875 20.25 15.9236 20.25 14.75H18.75H17.25C17.25 14.2668 17.6418 13.875 18.125 13.875V15.375ZM18.75 14.75H20.25C20.25 12.5409 18.4591 10.75 16.25 10.75V12.25V13.75C16.8023 13.75 17.25 14.1977 17.25 14.75H18.75ZM15.1607 18.3393L14.1 17.2787L12.6893 18.6893L13.75 19.75L14.8107 20.8107L16.2213 19.4L15.1607 18.3393Z"
        fill="white"
        mask="url(#path-1-outside-1_27799_28615)"
      />
    </>
  ),
  outline: false,
};

export const crown = {
  path: () => (
    <>
      <path
        d="M3.01167 7.14065C2.89395 6.43437 3.69224 5.941 4.27132 6.36214L8.19027 9.21229L10.9993 4.3969C11.308 3.8677 12.0726 3.8677 12.3813 4.3969L15.1903 9.21229L19.1092 6.36214C19.6883 5.941 20.4866 6.43437 20.3689 7.14065L18.8017 15.5438C18.7374 15.9296 18.4036 16.2123 18.0126 16.2123H5.36797C4.9769 16.2123 4.64315 15.9296 4.57886 15.5438L3.01167 7.14065Z"
        fill="currentColor"
      />
      <path
        d="M4.69027 18.2123C4.69027 17.66 5.13799 17.2123 5.69027 17.2123H17.6903C18.2426 17.2123 18.6903 17.66 18.6903 18.2123V19.2123C18.6903 19.7646 18.2426 20.2123 17.6903 20.2123H5.69027C5.13799 20.2123 4.69027 19.7646 4.69027 19.2123V18.2123Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};

export const shield = {
  path: () => (
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.69884 5.99999C6.30876 5.95102 9.59785 4.5737 12.0995 2.33466C14.6012 4.5737 17.8903 5.95102 21.5002 5.99999C21.6313 6.78092 21.6995 7.58316 21.6995 8.40134C21.6995 14.6712 17.6924 20.0051 12.0995 21.9819C6.50659 20.0051 2.49951 14.6712 2.49951 8.40134C2.49951 7.58316 2.56775 6.78092 2.69884 5.99999Z"
      fill="currentColor"
    />
  ),
  outline: false,
};

export const hierarchy = {
  path: () => (
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.4541 3C7.00639 3 7.4541 3.44772 7.4541 4V5.63672H16.5459V4C16.5459 3.44772 16.9936 3 17.5459 3H21C21.5523 3 22 3.44772 22 4V9.27246C22 9.82475 21.5523 10.2725 21 10.2725H17.5459C16.9936 10.2725 16.5459 9.82475 16.5459 9.27246V7.63672H13V14.6367C13.0003 15.1887 13.448 15.6367 14 15.6367H16.5459V14C16.5459 13.4477 16.9936 13 17.5459 13H21C21.5523 13 22 13.4477 22 14V19.2725C22 19.8247 21.5523 20.2725 21 20.2725H17.5459C16.9936 20.2725 16.5459 19.8247 16.5459 19.2725V17.6367H14C12.3434 17.6367 11.0003 16.2933 11 14.6367V7.63672H7.4541V9.27246C7.4541 9.82475 7.00639 10.2725 6.4541 10.2725H3C2.44772 10.2725 2 9.82475 2 9.27246V4C2 3.44772 2.44772 3 3 3H6.4541Z"
      fill="currentColor"
    />
  ),
  outline: false,
};

export const versionHistory = {
  path: () => (
    <>
      <path
        d="M12 21C13.25 21 14.4208 20.7625 15.5125 20.2875C16.6042 19.8125 17.5542 19.1708 18.3625 18.3625C19.1708 17.5542 19.8125 16.6042 20.2875 15.5125C20.7625 14.4208 21 13.25 21 12C21 10.75 20.7625 9.57917 20.2875 8.4875C19.8125 7.39583 19.1708 6.44583 18.3625 5.6375C17.5542 4.82917 16.6042 4.1875 15.5125 3.7125C14.4208 3.2375 13.25 3 12 3C10.6333 3 9.3375 3.29167 8.1125 3.875C6.8875 4.45833 5.85 5.28333 5 6.35V5C5 4.71667 4.90417 4.47917 4.7125 4.2875C4.52083 4.09583 4.28333 4 4 4C3.71667 4 3.47917 4.09583 3.2875 4.2875C3.09583 4.47917 3 4.71667 3 5V9C3 9.28333 3.09583 9.52083 3.2875 9.7125C3.47917 9.90417 3.71667 10 4 10H8C8.28333 10 8.52083 9.90417 8.7125 9.7125C8.90417 9.52083 9 9.28333 9 9C9 8.71667 8.90417 8.47917 8.7125 8.2875C8.52083 8.09583 8.28333 8 8 8H6.25C6.93333 7.06667 7.775 6.33333 8.775 5.8C9.775 5.26667 10.85 5 12 5C13.95 5 15.6042 5.67917 16.9625 7.0375C18.3208 8.39583 19 10.05 19 12C19 13.95 18.3208 15.6042 16.9625 16.9625C15.6042 18.3208 13.95 19 12 19C10.4167 19 9 18.525 7.75 17.575C6.5 16.625 5.675 15.4 5.275 13.9C5.19167 13.6333 5.04167 13.4333 4.825 13.3C4.60833 13.1667 4.36667 13.1167 4.1 13.15C3.81667 13.1833 3.59167 13.3042 3.425 13.5125C3.25833 13.7208 3.20833 13.95 3.275 14.2C3.75833 16.1833 4.80833 17.8125 6.425 19.0875C8.04167 20.3625 9.9 21 12 21Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 8.00002C12.5523 8.00002 13 8.44773 13 9.00002V12.5858L14.7071 14.2929C15.0976 14.6834 15.0976 15.3166 14.7071 15.7071C14.3166 16.0976 13.6834 16.0976 13.2929 15.7071L11.2929 13.7071C11.1054 13.5196 11 13.2652 11 13V9.00002C11 8.44773 11.4477 8.00002 12 8.00002Z"
        fill="currentColor"
      />
    </>
  ),
  outline: false,
};
